// @ts-nocheck
/* eslint-disable */
// GENERATED from server/utils/sheetEvaluator.js - do not edit. Rebuild with `npm run mrcs:client-sheet`.
// The table's copy of the sheet engine (issue 1499; docs/MRCS/workbench.md §7);
// scripts/__tests__/mrcs-client-sheet.test.js fails when it drifts.
/**
 * THE DERIVED-STAT EVALUATOR — issue #328, the first code in the sheet
 * workstream (docs/CHARACTERS/02-plan.md §2.3, 04-sheet-declaration.md §2).
 *
 * A character sheet is declared per game system, and every rule in a
 * declaration is a closed set of operations over a JSON tree: no expression
 * strings, no eval, no user code. Every one of the baseline workbook's 801
 * formulas is a table lookup plus arithmetic, so the language needs no
 * procedural power — and must not have any, because rules may one day be
 * authored by strangers on the path homebrew took. Today that constraint is
 * defence in depth (#327 deferred user-authored sheets); built this way, the
 * evaluator can become a hostile-input boundary later without a redesign.
 *
 * Three properties carry the design, in the order they matter:
 *
 * 1. DECLINING IS A FIRST-CLASS RESULT. 144 of 875 class entries carry no
 *    advancement table on any printing we hold, so "cannot compute, and here
 *    is why" is the COMMON path. A field that cannot be computed returns
 *    `status: 'unknown'` with a reason — never a throw, never a 0, never a
 *    NaN. A sheet that silently prints a wrong total is worse than one that
 *    admits it does not know. Distinct from it, `status: 'invalid'` means the
 *    RULE is defective (unknown operation, malformed node, cycle, depth):
 *    unknown is about the character's data, invalid is about the declaration.
 *    Both leave every other field computing.
 *
 * 2. PROVENANCE IS IN THE OUTPUT SHAPE. Every contribution to a derived
 *    number identifies where it came from — #273 decision 4 makes this a
 *    property of the modifier, not a debugging aid, and it applies to core
 *    rules as much as to homebrew. Origins are OPAQUE TOKENS the caller
 *    supplies ('system:dnd-3.5', 'layer:42'); the evaluator only carries
 *    them. Two views of the same fact: `sources` enumerates everything that
 *    fed the value (build inputs, content attributes, tables, upstream
 *    fields, rule fragments, modifiers), deduplicated and transitive across
 *    sheet.* hops; `contributions` itemizes the additive assembly (the rule's
 *    own result, then each modifier) for the "what fed this number" display
 *    a later slice draws.
 *
 * 3. THE THREE STATES STAY DISTINGUISHABLE. An authored input lives in
 *    `build` and is never restated here; a computed value is `value`; a value
 *    the player pinned by hand arrives in `overrides`, wins on `display`, is
 *    flagged `override.applied`, and NEVER overwrites the computed value it
 *    shadows.
 *
 * The module is deliberately dependency-free (a test asserts it contains no
 * `require`): 04 §3 wants one evaluator run on the server and in the browser,
 * so nothing in here may touch Node, the DOM, a database or a clock.
 * Everything it reads arrives as data — including content entries, which the
 * caller resolves (through the registry and the reader's stack) into a plain
 * `{ address: { attrs, origin } }` map before calling in.
 */
'use strict';
/** Rule trees are authored data with a declared shape, so a hostile or
 * runaway depth is refused rather than allowed to approach the JS stack
 * limit. 64 is an order of magnitude beyond the deepest rule in the baseline
 * workbook's hard cases (the skill-total rule nests 6 deep). */
const MAX_DEPTH = 64;
/** The most sheet.* hops (one field's rule reading another's) open at once,
 * and the most rule depth summed along them: well inside the JS stack. */
const MAX_HOPS = 100;
const MAX_CHAIN_DEPTH = 320;
/** The closed operation set. Growing it is a deliberate act: add the name
 * here, the case in evalOp, and the argument for it in the same commit —
 * the enumeration test in sheet-evaluator.test.js will insist. `compare`
 * from 04 §2's list is spelled as the six comparison operators, which is
 * how that document's own examples use it. */
const OPERATIONS = new Set([
    'sum', 'sub', 'mul', 'div', 'min', 'max',
    'floor', 'ceil', 'round',
    'if', 'eq', 'ne', 'gt', 'gte', 'lt', 'lte',
    'count', 'each', 'first', 'at', 'lookup', 'concat', 'ref',
    // Issue 924 (07-builder-v2-plan §3.3/§3.4), each argued for in 04 §2:
    'mod', 'sqrt', 'pow', 'abs', 'avg', 'clamp', 'and', 'or', 'not', 'dice',
    // qa-runs 363: a sheet DECLARES where an absent value counts as something
    // (an unchosen race adds 0 to Strength); argued for in 04 §2a.
    'optional',
]);
/** What `optional` answers for (qa-runs 363): an input nobody has set yet, or
 * a content entry that publishes nothing for the attribute. Every other
 * decline - a race typed as a name, a broken table, a bad rule - still
 * declines, because reading those as 0 would be a guess. */
// 'missing-key' (qa-runs 390): a keyed read of a table that has no such entry - a spell's level in a domain it is
// not in - is absent, as a missing attribute is, so `optional` may answer it.
const OPTIONAL_CODES = new Set(['missing-input', 'missing-content-attr', 'missing-key']);
/** `round`'s optional modes (issue 924): `{ round: { value, mode } }`. A
 * bare `{ round: <node> }` keeps Math.round's behaviour. */
const ROUND_MODES = new Set(['down', 'up', 'half_up', 'toward_zero']);
const COMPARISONS = new Set(['eq', 'ne', 'gt', 'gte', 'lt', 'lte']);
/** Modifier modes the pass applies over a field's rule result: `add` (a
 * bonus or penalty), `mul` ("halve your speed") and `set` ("your Strength
 * is now 1") - issue 665, epic 652 decision A. Still a closed set refused by
 * name: a mode outside it is a mode nobody has defined the arithmetic of.
 *
 * WITH `mul` AND `set` THE ORDER CHANGES THE ANSWER, so a modifier carries a
 * `position` (the order it landed) and the pass walks them in that order:
 * Strength 18, a poison that sets it to 1, a buff of +4 - 5 in one order and
 * 1 in the other. Modifiers with no position keep their list order and go
 * first (a layer's house rules land before a character's effects).
 *
 * TYPED STACKING comes before the walk (issue 665, item 3 of the decision):
 * the system declares, as content, which bonus types stack and which take
 * the highest of their kind (`stacking` on `evaluateSheet`), so a +4 and a
 * +2 enhancement give +4 whatever order they landed. Only `add` modifiers
 * with a positive value are subject to it; penalties always stack, and a
 * `mul` or `set` is never "the same kind" as another. A suppressed one
 * stays in the contributions with `applied: false` and the reason, so the
 * sheet can show a player why their second belt of Strength did nothing.
 *
 * A MODIFIER FOR SOME ROWS (issue 1506, feats.md §5) carries `where`, a rule
 * read in the scope of the row of a repeating list being computed: it counts
 * on the rows that rule is true of and is absent from the others (Weapon
 * Focus on the longsword's row only). Its value is read on the same row. */
const MODIFIER_MODES = new Set(['add', 'mul', 'set']);
/** The modifiers of one field, stacking applied, in application order. */
function stackModifiers(list, stacking) {
    const rules = stacking && typeof stacking === 'object' ? stacking : { default: 'stack', types: {} };
    const ordered = list
        .map((m, i) => ({ m, i, pos: typeof m.position === 'number' ? m.position : -1 }))
        .sort((a, b) => (a.pos - b.pos) || (a.i - b.i))
        .map((x) => x.m);
    const winners = new Map(); // bonus type -> index of the highest positive add
    const best = new Map();
    ordered.forEach((m, i) => {
        if (m.mode !== 'add' || typeof m.value !== 'number' || m.value <= 0)
            return;
        const type = typeof m.bonus_type === 'string' ? m.bonus_type : null;
        if (type === null)
            return;
        const rule = (rules.types && rules.types[type]) || rules.default || 'stack';
        if (rule !== 'highest')
            return;
        if (!best.has(type) || m.value > best.get(type)) {
            best.set(type, m.value);
            winners.set(type, i);
        }
    });
    return ordered.map((m, i) => {
        const type = typeof m.bonus_type === 'string' ? m.bonus_type : null;
        const suppressed = type !== null && winners.has(type) && winners.get(type) !== i
            && m.mode === 'add' && typeof m.value === 'number' && m.value > 0;
        return { m, applied: !suppressed };
    });
}
// ---------------------------------------------------------------------------
// Result plumbing. Internally a node evaluates to either
//   { value, sources }                                — success
//   { halt: { status: 'unknown'|'invalid', reason } } — a typed non-answer
// and halts propagate outward unchanged, so the reason a field states is the
// reason of the first thing that could not answer, not a vague wrapper.
// ---------------------------------------------------------------------------
function ok(value, sources) {
    return { value, sources: sources || [] };
}
function unknown(code, message) {
    return { halt: { status: 'unknown', reason: { code, message } } };
}
function invalid(code, message) {
    return { halt: { status: 'invalid', reason: { code, message } } };
}
/** The strict numeric reading, mirroring server/utils/authoredNumeric.js one
 * layer down: a JSON number passes, a string that is a plain numeric literal
 * passes (authored content stores "2" often enough that refusing it would be
 * a content change, not a guard), and everything else is UNANSWERABLE — it
 * never reads as 0, NaN or a truthy surprise. */
const NUMERIC_LITERAL = /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/;
// ---------------------------------------------------------------------------
// EXACT NUMBERS (issue 924, 07-builder-v2-plan §3.2). Arithmetic runs on
// rationals so 6 - 5.5 is exactly 1/2 and 0.1 + 0.2 is exactly 3/10, not the
// float's nearest neighbour. Internally a number ("Num") is one of two
// things, and the split is what keeps the common case fast:
//
//   · a JS number that is a SAFE INTEGER - every 3.5 total is one, so the
//     real-content suite never touches BigInt;
//   · a `Rat` { n, d } of BigInts, reduced, d > 0 - everything else (a
//     fraction, or an integer past 2^53).
//
// `make` normalizes, so a Rat is never an integer that fits a JS number, and
// the fast path can test `typeof x === 'number'`. Stored values never change
// shape: a build value is still a JSON number or a numeric string, and the
// DECIMAL TEXT is what is read - 0.1 is 1/10, not the float's binary value.
// A result leaves the evaluator as `value` (a JS number, as before) and
// `exact` ("1/2", or "3").
// ---------------------------------------------------------------------------
class Rat {
    constructor(n, d) { this.n = n; this.d = d; }
}
const MAX_SAFE_BIG = BigInt(Number.MAX_SAFE_INTEGER);
const TWO_53 = 2n ** 53n;
function bigAbs(n) { return n < 0n ? -n : n; }
function gcd(a, b) {
    a = bigAbs(a);
    b = bigAbs(b);
    while (b !== 0n) {
        const t = a % b;
        a = b;
        b = t;
    }
    return a;
}
/** A reduced Num from a numerator and a non-zero denominator. */
function make(n, d) {
    if (d < 0n) {
        n = -n;
        d = -d;
    }
    if (d !== 1n) {
        const g = gcd(n, d);
        if (g !== 1n) {
            n /= g;
            d /= g;
        }
    }
    if (d === 1n && n <= MAX_SAFE_BIG && n >= -MAX_SAFE_BIG)
        return Number(n);
    return new Rat(n, d);
}
function toND(x) {
    return typeof x === 'number' ? [BigInt(x), 1n] : [x.n, x.d];
}
const DECIMAL = /^([+-]?)([0-9]*)(?:[.]([0-9]*))?(?:[eE]([+-]?[0-9]+))?$/;
/** The exact value a decimal text states. The caller has already decided the
 * text is acceptable (strict for stored strings; String(n) for a JS number,
 * whose text may carry an exponent). */
function parseDecimal(text) {
    const m = DECIMAL.exec(text);
    const intPart = m[2] || '';
    const frac = m[3] || '';
    if (!m[4] && /^0*$/.test(frac) && intPart.length <= 15) {
        const v = Number(intPart || '0');
        return m[1] === '-' && v !== 0 ? -v : v;
    }
    let n = BigInt((intPart + frac) || '0');
    if (m[1] === '-')
        n = -n;
    const exp = (m[4] ? Number(m[4]) : 0) - frac.length;
    return exp >= 0 ? make(n * 10n ** BigInt(exp), 1n) : make(n, 10n ** BigInt(-exp));
}
/** A finite JS number as a Num, read through its shortest decimal text. */
function numFromJs(v) {
    if (Number.isSafeInteger(v))
        return v === 0 ? 0 : v;
    return parseDecimal(String(v));
}
function isZero(x) { return x === 0; }
function sign(x) { return typeof x === 'number' ? Math.sign(x) : (x.n < 0n ? -1 : 1); }
function qAdd(a, b) {
    if (typeof a === 'number' && typeof b === 'number') {
        const r = a + b;
        if (Number.isSafeInteger(r))
            return r;
    }
    const [an, ad] = toND(a);
    const [bn, bd] = toND(b);
    return make(an * bd + bn * ad, ad * bd);
}
function qNeg(a) { return typeof a === 'number' ? (a === 0 ? 0 : -a) : new Rat(-a.n, a.d); }
function qSub(a, b) { return qAdd(a, qNeg(b)); }
function qMul(a, b) {
    if (typeof a === 'number' && typeof b === 'number') {
        const r = a * b;
        if (Number.isSafeInteger(r))
            return r === 0 ? 0 : r;
    }
    const [an, ad] = toND(a);
    const [bn, bd] = toND(b);
    return make(an * bn, ad * bd);
}
/** b is never zero here: every caller declines division by zero first. */
function qDiv(a, b) {
    if (typeof a === 'number' && typeof b === 'number' && a % b === 0) {
        const r = a / b;
        return r === 0 ? 0 : r;
    }
    const [an, ad] = toND(a);
    const [bn, bd] = toND(b);
    return make(an * bd, ad * bn);
}
function qCmp(a, b) {
    if (typeof a === 'number' && typeof b === 'number')
        return a < b ? -1 : (a > b ? 1 : 0);
    const [an, ad] = toND(a);
    const [bn, bd] = toND(b);
    const l = an * bd;
    const r = bn * ad;
    return l < r ? -1 : (l > r ? 1 : 0);
}
function qFloor(x) {
    if (typeof x === 'number')
        return x;
    let q = x.n / x.d; // BigInt division truncates toward zero
    if (x.n < 0n && q * x.d !== x.n)
        q -= 1n;
    return make(q, 1n);
}
function qCeil(x) { return qNeg(qFloor(qNeg(x))); }
function qTrunc(x) { return sign(x) < 0 ? qCeil(x) : qFloor(x); }
const HALF = new Rat(1n, 2n);
/** `round` with no mode - exactly Math.round: halves go toward +infinity
 * (2.5 → 3, -2.5 → -2), as it always has. */
function qRoundDefault(x) { return typeof x === 'number' ? x : qFloor(qAdd(x, HALF)); }
/** `half_up`: halves go AWAY FROM ZERO (2.5 → 3, -2.5 → -3), as a
 * spreadsheet's ROUND does and as a person rounding by hand does. */
function qRoundHalfAway(x) {
    if (typeof x === 'number')
        return x;
    return sign(x) < 0 ? qNeg(qFloor(qAdd(qNeg(x), HALF))) : qFloor(qAdd(x, HALF));
}
function qAbs(x) { return sign(x) < 0 ? qNeg(x) : x; }
/** Floored remainder: the result takes the sign of the divisor. */
function qMod(a, b) {
    if (typeof a === 'number' && typeof b === 'number') {
        let r = a % b;
        if (r !== 0 && (r < 0) !== (b < 0))
            r += b;
        return r === 0 ? 0 : r;
    }
    return qSub(a, qMul(b, qFloor(qDiv(a, b))));
}
/** The JS number nearest the Num - `value`, for every existing consumer. */
function toNumber(x) {
    if (typeof x === 'number')
        return x;
    const an = bigAbs(x.n);
    if (an <= TWO_53 && x.d <= TWO_53)
        return Number(x.n) / Number(x.d);
    // Past 2^53 the division is done in decimal: 20 places, and at least 21
    // significant digits, so a tiny value (1/2^60) keeps its precision too.
    const k = Math.max(20, x.d.toString().length - an.toString().length + 21);
    const v = parseFloat(`${(an * 10n ** BigInt(k)) / x.d}e-${k}`);
    return x.n < 0n ? -v : v;
}
/** The exact text of a Num: "3", "-1/2". */
function exactText(x) {
    if (typeof x === 'number')
        return String(x);
    return x.d === 1n ? String(x.n) : `${x.n}/${x.d}`;
}
/** Integer k-th root, floored, of a non-negative BigInt (Newton's method
 * from an overestimate, which descends monotonically onto the floor). */
function iroot(n, k) {
    if (n < 2n)
        return n;
    const K = BigInt(k);
    const bits = n.toString(2).length;
    let x = 1n << BigInt(Math.ceil(bits / k));
    for (;;) {
        const y = ((K - 1n) * x + n / (x ** (K - 1n))) / K;
        if (y >= x)
            return x;
        x = y;
    }
}
/** The places an inexact root is rounded to (07 §3.2). */
const INEXACT_PLACES = 12;
const INEXACT_SCALE = 10n ** BigInt(INEXACT_PLACES);
/** The largest root index taken exactly; a finer fractional exponent is
 * computed in floating point and rounded to the same places. */
const MAX_ROOT = 64;
/** A result wider than this many bits declines rather than computing. */
const MAX_BITS = 4096;
function bitLength(n) { return bigAbs(n).toString(2).length; }
/** The k-th root of a non-negative Num: { num, exact }. Exact when the root
 * is rational (the numerator and denominator are both perfect k-th powers);
 * otherwise rounded half-up to INEXACT_PLACES in integer arithmetic, so the
 * answer is the same on every engine. */
function qRoot(x, k) {
    const [n, d] = toND(x);
    const rn = iroot(n, k);
    const rd = iroot(d, k);
    if (rn ** BigInt(k) === n && rd ** BigInt(k) === d)
        return { num: make(rn, rd), exact: true };
    const S = 2n * INEXACT_SCALE;
    const R = iroot((n * S ** BigInt(k)) / d, k); // floor(2·10^12 · root)
    return { num: make((R + 1n) / 2n, INEXACT_SCALE), exact: false };
}
/** A Num raised to an integer power, or null when the result is too wide. */
function qPowInt(x, p) {
    const [n, d] = toND(x);
    const P = BigInt(Math.abs(p));
    if ((bitLength(n) + bitLength(d)) * Math.abs(p) > MAX_BITS)
        return null;
    return p >= 0 ? make(n ** P, d ** P) : make(d ** P, n ** P);
}
// ---------------------------------------------------------------------------
// DICE EXPRESSIONS (issue 924, 07 §3.4): stored as { dice: [{ count, sides }],
// bonus }. Internally a `Dice` of merged pools and a Num bonus. `sum` is the
// one arithmetic that understands one; anything else declines not-numeric.
// ---------------------------------------------------------------------------
class Dice {
    constructor(pools, bonus) { this.pools = pools; this.bonus = bonus; }
}
const isPosInt = (v, min) => typeof v === 'number' && Number.isSafeInteger(v) && v >= min;
/** A value as Dice, or null: an internal Dice, or the stored shape. */
function asDice(v) {
    if (v instanceof Dice)
        return v;
    if (v === null || typeof v !== 'object' || Array.isArray(v) || !Array.isArray(v.dice))
        return null;
    if (Object.keys(v).some((k) => k !== 'dice' && k !== 'bonus'))
        return null;
    const pools = [];
    for (const p of v.dice) {
        if (p === null || typeof p !== 'object' || !isPosInt(p.count, 0) || !isPosInt(p.sides, 1))
            return null;
        pools.push({ count: p.count, sides: p.sides });
    }
    let bonus = 0;
    if (v.bonus !== undefined) {
        const b = asNumber(v.bonus, 'a dice bonus');
        if (b.halt)
            return null;
        bonus = b.num;
    }
    return new Dice(mergePools([], pools), bonus);
}
/** Pools merged: the same sides combine their counts, in first-seen order,
 * and a pool of no dice drops out. */
function mergePools(into, pools) {
    const out = into.map((p) => ({ ...p }));
    for (const p of pools) {
        const same = out.find((q) => q.sides === p.sides);
        if (same)
            same.count += p.count;
        else
            out.push({ count: p.count, sides: p.sides });
    }
    return out.filter((p) => p.count > 0);
}
function diceText(x) {
    const pools = x.pools.map((p) => `${p.count}d${p.sides}`).join('+');
    if (!pools)
        return exactText(x.bonus);
    if (isZero(x.bonus))
        return pools;
    return sign(x.bonus) < 0 ? `${pools}-${exactText(qNeg(x.bonus))}` : `${pools}+${exactText(x.bonus)}`;
}
/** How a value leaves the evaluator: { value, exact?, text? }. A Num becomes
 * a JS number with its exact text; a dice value becomes the stored shape with
 * its text ("1d8+3"); anything else is itself. */
function publicOf(v) {
    if (typeof v === 'number')
        return Number.isFinite(v) ? { value: v, exact: exactText(numFromJs(v)) } : { value: v };
    if (v instanceof Rat)
        return { value: toNumber(v), exact: exactText(v) };
    const dice = asDice(v);
    if (dice) {
        return { value: { dice: dice.pools, bonus: toNumber(dice.bonus) }, text: diceText(dice) };
    }
    return { value: v };
}
/** A value as plain text or a plain JS value where one is keyed or joined. */
function plainOf(v) {
    if (v instanceof Rat)
        return toNumber(v);
    if (v instanceof Dice)
        return diceText(v);
    return v;
}
function asNumber(v, what) {
    if (typeof v === 'number' && Number.isFinite(v))
        return { num: numFromJs(v) };
    if (v instanceof Rat)
        return { num: v };
    if (typeof v === 'string' && NUMERIC_LITERAL.test(v.trim()))
        return { num: parseDecimal(v.trim()) };
    return { halt: unknown('not-numeric', `${what} is ${JSON.stringify(plainOf(v))}, which does not read as a number`).halt };
}
/** obj[key] when it is obj's own property: a key like "constructor" must
 * never read Object.prototype (a field, table or build path may be named so). */
function own(obj, key) {
    return obj != null && Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
}
function getPath(obj, segs) {
    let cur = obj;
    for (const s of segs) {
        if (cur == null || typeof cur !== 'object')
            return undefined;
        cur = own(cur, s);
    }
    return cur;
}
function dedupeSources(sources) {
    const seen = new Set();
    const out = [];
    for (const s of sources) {
        const k = JSON.stringify(s);
        if (!seen.has(k)) {
            seen.add(k);
            out.push(s);
        }
    }
    return out;
}
// ---------------------------------------------------------------------------
// Reference resolution — the whole address space a rule may read (04 §2).
// ---------------------------------------------------------------------------
/** Resolve a content ADDRESS ('family/slug') to its attrs + origin. A bare
 * string that is not an address is decision 5 made concrete: a race we do
 * not hold is stored as its name and is not an error — but a rule reading
 * through it declines, with the name in the reason. */
function contentEntry(ctx, address) {
    if (typeof address !== 'string' || !address.includes('/')) {
        return unknown('unresolved-reference', `${JSON.stringify(address)} is not a resolvable reference — stored as text, so this value cannot be computed`);
    }
    const entry = own(ctx.content, address);
    if (entry === undefined) {
        return unknown('unresolved-reference', `no content entry resolves at "${address}"`);
    }
    return ok(entry);
}
function contentAttr(ctx, address, attrSegs) {
    const e = contentEntry(ctx, address);
    if (e.halt)
        return e;
    const entry = e.value;
    const attrs = entry.attrs || entry;
    const v = getPath(attrs, attrSegs);
    const attr = attrSegs.join('.');
    if (v === undefined) {
        return unknown('missing-content-attr', `content entry "${address}" carries no "${attr}" — declining to compute rather than guessing`);
    }
    return ok(v, [{ kind: 'content', ref: address, attr, origin: entry.origin !== undefined ? entry.origin : 'base' }]);
}
function resolveRef(ctx, refPath, depth) {
    if (typeof refPath !== 'string' || refPath.length === 0) {
        return invalid('bad-node', 'ref must be a non-empty string address');
    }
    const segs = refPath.split('.');
    const head = segs[0];
    if (head === 'build') {
        const v = getPath(ctx.build, segs.slice(1));
        if (v === undefined) {
            return unknown('missing-input', `no value at "${refPath}" — declining to compute rather than reading it as 0`);
        }
        return ok(v, [{ kind: 'input', path: refPath, origin: 'player' }]);
    }
    if (head === 'sheet') {
        if (segs.length === 3 && ctx.orderedTracks && own(ctx.orderedTracks, segs[1]) !== undefined) {
            return trackOutput(ctx, segs[1], segs[2]);
        }
        if (segs.length !== 2)
            return invalid('bad-node', `"${refPath}" — sheet references name a field key, nothing deeper`);
        return sheetFieldValue(ctx, segs[1], depth);
    }
    if (head === 'content') {
        // content.<slot>.<attr...>: the slot is bound to a build path by the
        // declaration's content_slots, because "the race" is not knowable from
        // the address alone — the doc left the binding unstated, and this is
        // the judgement: it is declaration data, not evaluator knowledge.
        if (segs.length < 3)
            return invalid('bad-node', `"${refPath}" — content references are content.<slot>.<attribute>`);
        const binding = own(ctx.contentSlots, segs[1]);
        if (binding === undefined) {
            return invalid('unknown-content-slot', `the declaration binds no content slot named "${segs[1]}"`);
        }
        const addr = getPath(ctx.build, binding.split('.').slice(1));
        if (addr === undefined) {
            return unknown('missing-input', `no value at "${binding}" to resolve content slot "${segs[1]}"`);
        }
        return contentAttr(ctx, addr, segs.slice(2));
    }
    if (Object.prototype.hasOwnProperty.call(ctx.scope, head)) {
        const item = ctx.scope[head];
        if (segs.length === 1)
            return ok(item.value, item.sources);
        if (segs[1] === 'content') {
            if (segs.length < 3)
                return invalid('bad-node', `"${refPath}" — item content references are <var>.content.<attribute>`);
            const addr = item.value && typeof item.value === 'object'
                ? (item.value.ref !== undefined ? item.value.ref : item.address)
                : undefined;
            // A row that links no entry yet (a weapon row with no weapon chosen)
            // has nothing to read through: that is an unanswered input, said so,
            // not a reference that failed to resolve (issue 1134).
            if (addr === undefined || addr === null || addr === '') {
                return unknown('missing-input', `this row links no entry, so "${refPath}" cannot be read`);
            }
            return contentAttr(ctx, addr, segs.slice(2));
        }
        const v = getPath(item.value, segs.slice(1));
        if (v === undefined) {
            return unknown('missing-input', `no value at "${refPath}" on ${item.address !== undefined ? `"${item.address}"` : 'this row'}`);
        }
        return ok(v, item.sources);
    }
    return invalid('bad-node', `"${refPath}" reads outside the address space (build.*, sheet.*, content.*, or a bound track/each variable)`);
}
// ---------------------------------------------------------------------------
// Node evaluation.
// ---------------------------------------------------------------------------
function numericOperands(ctx, nodes, depth, what) {
    const values = [];
    const sources = [];
    for (const n of nodes) {
        const r = evalNode(ctx, n, depth);
        if (r.halt)
            return r;
        const num = asNumber(r.value, what);
        if (num.halt)
            return { halt: num.halt };
        values.push(num.num);
        sources.push(...r.sources);
    }
    return ok(values, sources);
}
function requireArray(args, opName, arity) {
    if (!Array.isArray(args))
        return invalid('bad-node', `${opName} takes a list of operands`);
    if (arity !== undefined && args.length !== arity) {
        return invalid('bad-node', `${opName} takes exactly ${arity} operands, got ${args.length}`);
    }
    if (arity === undefined && args.length === 0) {
        return invalid('bad-node', `${opName} takes at least one operand`);
    }
    return null;
}
function evalNode(ctx, node, depth) {
    if (depth > MAX_DEPTH) {
        return invalid('max-depth', `rule tree deeper than ${MAX_DEPTH} — refused rather than recursed`);
    }
    if (typeof node === 'number') {
        if (!Number.isFinite(node))
            return invalid('bad-node', 'a literal must be a finite number');
        return ok(node);
    }
    if (typeof node === 'string' || typeof node === 'boolean')
        return ok(node);
    if (node === null || node === undefined || Array.isArray(node) || typeof node !== 'object') {
        return invalid('bad-node', `${JSON.stringify(node)} is not a rule node`);
    }
    // A node is ONE operation, optionally carrying an `origin` that re-labels
    // its subtree — the seam a layer-merged rule fragment uses. Any other key
    // arrangement is refused: closure is structural, not advisory.
    const keys = Object.keys(node).filter((k) => k !== 'origin');
    if (keys.length !== 1) {
        return invalid('bad-node', `a rule node carries exactly one operation, got [${Object.keys(node).join(', ')}]`);
    }
    const op = keys[0];
    if (!OPERATIONS.has(op)) {
        return invalid('unknown-operation', `"${op}" is not an operation this evaluator knows — the set is closed, and growing it is a deliberate act`);
    }
    let sub = ctx;
    const extraSources = [];
    if (node.origin !== undefined) {
        sub = { ...ctx, origin: node.origin };
        extraSources.push({ kind: 'rule', origin: node.origin });
    }
    const r = evalOp(sub, op, node[op], depth + 1);
    if (r.halt)
        return r;
    return ok(r.value, [...extraSources, ...r.sources]);
}
function evalOp(ctx, op, args, depth) {
    switch (op) {
        case 'ref':
            return resolveRef(ctx, args, depth);
        case 'sum':
            return evalSum(ctx, args, depth);
        case 'mul':
        case 'min':
        case 'max':
        case 'avg': {
            const bad = requireArray(args, op);
            if (bad)
                return bad;
            const r = numericOperands(ctx, args, depth, `an operand of ${op}`);
            if (r.halt)
                return r;
            const v = r.value;
            const folded = op === 'mul' ? v.reduce(qMul, 1)
                : op === 'min' ? v.reduce((a, b) => (qCmp(b, a) < 0 ? b : a))
                    : op === 'max' ? v.reduce((a, b) => (qCmp(b, a) > 0 ? b : a))
                        : qDiv(v.reduce(qAdd, 0), v.length);
            return ok(folded, r.sources);
        }
        case 'mod': {
            const bad = requireArray(args, op, 2);
            if (bad)
                return bad;
            const r = numericOperands(ctx, args, depth, `an operand of ${op}`);
            if (r.halt)
                return r;
            const [a, b] = r.value;
            if (isZero(b))
                return unknown('division-by-zero', 'a remainder by zero — declining rather than serving NaN');
            return ok(qMod(a, b), r.sources);
        }
        case 'pow': {
            const bad = requireArray(args, op, 2);
            if (bad)
                return bad;
            const r = numericOperands(ctx, args, depth, `an operand of ${op}`);
            if (r.halt)
                return r;
            return power(r.value[0], r.value[1], 'pow', r.sources);
        }
        case 'sqrt':
        case 'abs': {
            const r = evalNode(ctx, args, depth);
            if (r.halt)
                return r;
            const num = asNumber(r.value, `the operand of ${op}`);
            if (num.halt)
                return { halt: num.halt };
            return op === 'abs' ? ok(qAbs(num.num), r.sources) : power(num.num, HALF, 'sqrt', r.sources);
        }
        case 'optional': {
            // `{ optional: { value, else } }` (qa-runs 363): `value`, or `else` when
            // `value` declines only because something optional is absent. The
            // default stays "missing is never 0" (04 §2a); this is the sheet saying,
            // in one place, that here absence has a meaning. An unset choice marks
            // the result provisional ("more may apply"); the mark travels through
            // sheet.* as `inexact` does.
            if (args === null || typeof args !== 'object' || Array.isArray(args)) {
                return invalid('bad-node', 'optional takes { value, else }');
            }
            // `settled: true` (qa-runs 395): absence here is the whole answer, not
            // a choice still to make - a level with no hit point roll counts as
            // the average - so the result is not marked "more may apply".
            const bad = exactKeys(args, ['value', 'else'], 'optional', ['settled']);
            if (bad)
                return bad;
            if (args.settled !== undefined && typeof args.settled !== 'boolean') {
                return invalid('bad-node', 'optional.settled is true or false');
            }
            const r = evalNode(ctx, args.value, depth);
            if (!r.halt)
                return r;
            if (r.halt.status !== 'unknown' || !OPTIONAL_CODES.has(r.halt.reason.code))
                return r;
            const e = evalNode(ctx, args.else, depth);
            if (e.halt)
                return e;
            if (args.settled === true)
                return e;
            return ok(e.value, [...e.sources, { kind: 'absent', code: r.halt.reason.code,
                    origin: ctx.origin !== undefined ? ctx.origin : 'base' }]);
        }
        case 'clamp': {
            if (args === null || typeof args !== 'object' || Array.isArray(args)) {
                return invalid('bad-node', 'clamp takes { value, min, max }');
            }
            const bad = exactKeys(args, ['value', 'min', 'max'], 'clamp');
            if (bad)
                return bad;
            const r = numericOperands(ctx, [args.value, args.min, args.max], depth, 'an operand of clamp');
            if (r.halt)
                return r;
            const [v, lo, hi] = r.value;
            if (qCmp(lo, hi) > 0) {
                return unknown('empty-range', `clamp's min ${exactText(lo)} is above its max ${exactText(hi)} — no value lies between`);
            }
            return ok(qCmp(v, lo) < 0 ? lo : (qCmp(v, hi) > 0 ? hi : v), r.sources);
        }
        case 'and':
        case 'or': {
            const bad = requireArray(args, op);
            if (bad)
                return bad;
            // Short-circuits, as `if` evaluates only the branch it takes: once the
            // answer is known, a later operand that could not answer is not asked.
            const sources = [];
            for (const n of args) {
                const r = evalNode(ctx, n, depth);
                if (r.halt)
                    return r;
                const t = truthiness(r.value);
                if (t.halt)
                    return t;
                sources.push(...r.sources);
                if (t.value === (op === 'or'))
                    return ok(op === 'or', sources);
            }
            return ok(op === 'and', sources);
        }
        case 'not': {
            const r = evalNode(ctx, args, depth);
            if (r.halt)
                return r;
            const t = truthiness(r.value);
            if (t.halt)
                return t;
            return ok(!t.value, r.sources);
        }
        case 'dice': {
            if (args === null || typeof args !== 'object' || Array.isArray(args)) {
                return invalid('bad-node', 'dice takes { count, sides, bonus? }');
            }
            const bad = exactKeys(args, ['count', 'sides'], 'dice', ['bonus']);
            if (bad)
                return bad;
            const nodes = args.bonus === undefined ? [args.count, args.sides] : [args.count, args.sides, args.bonus];
            const r = numericOperands(ctx, nodes, depth, 'an operand of dice');
            if (r.halt)
                return r;
            const [count, sides, bonus = 0] = r.value;
            if (!isPosInt(count, 0) || !isPosInt(sides, 1)) {
                return unknown('not-dice', `${exactText(count)}d${exactText(sides)} is not a roll — a count is a whole number from 0 and sides a whole number from 1`);
            }
            return ok(new Dice(mergePools([], [{ count, sides }]), bonus), r.sources);
        }
        case 'sub':
        case 'div': {
            const bad = requireArray(args, op, 2);
            if (bad)
                return bad;
            const r = numericOperands(ctx, args, depth, `an operand of ${op}`);
            if (r.halt)
                return r;
            const [a, b] = r.value;
            if (op === 'div' && isZero(b)) {
                return unknown('division-by-zero', 'division by zero — declining rather than serving Infinity');
            }
            return ok(op === 'sub' ? qSub(a, b) : qDiv(a, b), r.sources);
        }
        case 'floor':
        case 'ceil':
        case 'round': {
            // `round` alone takes a mode, as { value, mode }: an object argument
            // carrying `mode` is that form (no operation is named `mode`).
            let operand = args;
            let mode = null;
            if (op === 'round' && args !== null && typeof args === 'object' && !Array.isArray(args)
                && Object.prototype.hasOwnProperty.call(args, 'mode')) {
                const bad = exactKeys(args, ['value', 'mode'], 'round');
                if (bad)
                    return bad;
                if (!ROUND_MODES.has(args.mode)) {
                    return invalid('bad-node', `round's mode must be one of [${[...ROUND_MODES].join(', ')}]`);
                }
                operand = args.value;
                mode = args.mode;
            }
            const r = evalNode(ctx, operand, depth);
            if (r.halt)
                return r;
            const num = asNumber(r.value, `the operand of ${op}`);
            if (num.halt)
                return { halt: num.halt };
            const x = num.num;
            const out = op === 'floor' || mode === 'down' ? qFloor(x)
                : op === 'ceil' || mode === 'up' ? qCeil(x)
                    : mode === 'toward_zero' ? qTrunc(x)
                        : mode === 'half_up' ? qRoundHalfAway(x)
                            : qRoundDefault(x);
            return ok(out, r.sources);
        }
        case 'eq':
        case 'ne':
        case 'gt':
        case 'gte':
        case 'lt':
        case 'lte': {
            const bad = requireArray(args, op, 2);
            if (bad)
                return bad;
            const l = evalNode(ctx, args[0], depth);
            if (l.halt)
                return l;
            const r = evalNode(ctx, args[1], depth);
            if (r.halt)
                return r;
            return compareValues(op, l.value, r.value, [...l.sources, ...r.sources]);
        }
        case 'if': {
            if (args === null || typeof args !== 'object' || Array.isArray(args)) {
                return invalid('bad-node', 'if takes { cond, then, else }');
            }
            // `else` is required: a conditional with no else is an unknown value
            // waiting to happen, and the workbook's own conditionals all have one.
            for (const k of ['cond', 'then', 'else']) {
                if (args[k] === undefined)
                    return invalid('bad-node', `if is missing its "${k}" branch`);
            }
            const extra = Object.keys(args).filter((k) => !['cond', 'then', 'else'].includes(k));
            if (extra.length)
                return invalid('bad-node', `if does not take [${extra.join(', ')}]`);
            const c = evalNode(ctx, args.cond, depth);
            if (c.halt)
                return c;
            const t = truthiness(c.value);
            if (t.halt)
                return t;
            const branch = evalNode(ctx, t.value ? args.then : args.else, depth);
            if (branch.halt)
                return branch;
            return ok(branch.value, [...c.sources, ...branch.sources]);
        }
        case 'count': {
            if (args === null || typeof args !== 'object' || Array.isArray(args)) {
                return invalid('bad-node', 'count takes { of, where }');
            }
            if (!Array.isArray(args.of))
                return invalid('bad-node', 'count.of is a list of nodes');
            if (args.where === null || typeof args.where !== 'object' || Array.isArray(args.where)) {
                return invalid('bad-node', 'count.where is a single comparison, e.g. { "gte": 1 }');
            }
            const wkeys = Object.keys(args.where);
            if (wkeys.length !== 1 || !COMPARISONS.has(wkeys[0])) {
                return invalid('bad-node', `count.where must be one of [${[...COMPARISONS].join(', ')}]`);
            }
            const cmpOp = wkeys[0];
            const threshold = evalNode(ctx, args.where[cmpOp], depth);
            if (threshold.halt)
                return threshold;
            let n = 0;
            const sources = [...threshold.sources];
            for (const item of args.of) {
                const r = evalNode(ctx, item, depth);
                if (r.halt)
                    return r;
                const c = compareValues(cmpOp, r.value, threshold.value, []);
                if (c.halt)
                    return c;
                if (c.value)
                    n += 1;
                sources.push(...r.sources);
            }
            return ok(n, sources);
        }
        case 'each': {
            if (args === null || typeof args !== 'object' || Array.isArray(args)) {
                return invalid('bad-node', 'each takes { over, as, do }');
            }
            if (typeof args.as !== 'string' || !args.as)
                return invalid('bad-node', 'each.as names the loop variable');
            if (args.do === undefined)
                return invalid('bad-node', 'each is missing its "do" rule');
            const items = countedRows(ctx, args.over, depth);
            if (items.halt)
                return items;
            // each is map-plus-SUM (02-plan §2.3: "sum over a repeated thing") —
            // the only aggregation the baseline sheet uses. An empty track sums
            // to 0, which is the right answer for "hit points of no classes".
            // `most: true` keeps the largest instead (qa-runs 1225): a requirement
            // reads the best single row, never three Craft rows added up.
            let total = 0;
            const sources = [...items.sources];
            for (const item of items.value) {
                const inner = { ...ctx, scope: { ...ctx.scope, [args.as]: item } };
                const r = evalNode(inner, args.do, depth);
                if (r.halt)
                    return r;
                const num = asNumber(r.value, 'an each iteration result');
                if (num.halt)
                    return { halt: num.halt };
                total = args.most === true ? Math.max(total, num.num) : qAdd(total, num.num);
                sources.push(...r.sources);
            }
            return ok(total, sources);
        }
        case 'first': {
            // The FIRST row of an ordered list, with `do` evaluated in its scope
            // (issue 635, epic 358's deferral, decided A on the issue): "the first
            // class's skill points times four" is a fact about the game that the
            // language could not say, since nothing indexed an ordered list by
            // position. Shaped like `each` - over, as, do - so it binds the row
            // the same way and the editor offers it the same way. An empty list
            // DECLINES rather than reading as 0: a character with no class has no
            // first class, and the question is unanswerable, not answered by zero.
            if (args === null || typeof args !== 'object' || Array.isArray(args)) {
                return invalid('bad-node', 'first takes { over, as, do }');
            }
            if (typeof args.as !== 'string' || !args.as)
                return invalid('bad-node', 'first.as names the row variable');
            if (args.do === undefined)
                return invalid('bad-node', 'first is missing its "do" rule');
            const items = countedRows(ctx, args.over, depth);
            if (items.halt)
                return items;
            if (!items.value.length)
                return unknown('empty-list', `"${args.over}" has no rows, so it has no first row`);
            const inner = { ...ctx, scope: { ...ctx.scope, [args.as]: items.value[0] } };
            const r = evalNode(inner, args.do, depth);
            if (r.halt)
                return r;
            return ok(r.value, [...items.sources, ...r.sources]);
        }
        case 'at': {
            if (args === null || typeof args !== 'object' || Array.isArray(args)) {
                return invalid('bad-node', 'at takes { of, index, else? }');
            }
            const of = evalNode(ctx, args.of, depth);
            if (of.halt)
                return of;
            const idx = evalNode(ctx, args.index, depth);
            if (idx.halt)
                return idx;
            // `else` (optional): what the read answers when the entry is not there,
            // where the rules give an absent entry a meaning - a weapon that says
            // nothing of how Strength applies to it takes Strength in full (the
            // bug-fix pass of issue 1134). Without it, an absent entry declines.
            const absent = (halt) => {
                if (args.else === undefined)
                    return halt;
                const r = evalNode(ctx, args.else, depth);
                if (r.halt)
                    return r;
                return ok(r.value, [...of.sources, ...idx.sources, ...r.sources]);
            };
            // A KEYED table read out of content (issue 1134): `of` an object and
            // `index` a text key - a weapon's damage by the wielder's size
            // ({ "medium": 1d8, "large": 2d6 }), where the key is itself computed.
            // A key the object does not hold declines, as a level past a list's
            // end does; it never reads as 0. own() keeps "constructor" out.
            if (of.value !== null && typeof of.value === 'object' && !Array.isArray(of.value)
                && !(of.value instanceof Rat) && !(of.value instanceof Dice) && typeof idx.value === 'string') {
                const hit = own(of.value, idx.value);
                if (hit === undefined) {
                    return absent(unknown('missing-key', `there is no entry for ${JSON.stringify(idx.value)} in the table read`));
                }
                return ok(hit, [...of.sources, ...idx.sources]);
            }
            if (!Array.isArray(of.value)) {
                return unknown('not-a-list', 'at.of did not resolve to a per-level list');
            }
            const num = asNumber(idx.value, 'at.index');
            if (num.halt)
                return { halt: num.halt };
            // 1-based: level 1 reads the first row, the way the printed table is
            // read. A level past the table's end is DATA that cannot answer (a
            // 12th level against a 10-level prestige progression), so it declines.
            const i = num.num;
            // Level 0, or no class level yet, is nothing filled in, not a row past the table (issue 1455): it reads
            // "not set yet" as any missing input does.
            if (typeof i === 'number' && i < 1) {
                return absent(unknown('missing-input', `index ${exactText(i)} is below the table's first row: no level is set yet`));
            }
            if (typeof i !== 'number' || i > of.value.length) {
                return absent(unknown('index-out-of-range', `index ${exactText(i)} is outside the table's 1..${of.value.length} — the printed table has no such row`));
            }
            // A null entry is a cell the printed table leaves blank ("—": no spells of that level at all, qa-runs
            // 390), not a zero: it reads as absent, so `else` answers it, and without one it declines.
            if (of.value[i - 1] === null) {
                return absent(unknown('no-entry', `the table's row ${exactText(i)} is blank (a "—" in the printed table)`));
            }
            return ok(of.value[i - 1], [...of.sources, ...idx.sources]);
        }
        case 'lookup': {
            if (args === null || typeof args !== 'object' || Array.isArray(args)) {
                return invalid('bad-node', 'lookup takes { table, key, column? }');
            }
            const table = own(ctx.tables, args.table);
            if (table === undefined) {
                // A rule naming a table the declaration does not carry is a defect
                // in the declaration, not in the character: invalid, not unknown.
                return invalid('unknown-table', `the declaration carries no table named "${JSON.stringify(args.table)}"`);
            }
            const key = evalNode(ctx, args.key, depth);
            if (key.halt)
                return key;
            const rows = table.rows || {};
            const k = String(plainOf(key.value));
            if (!Object.prototype.hasOwnProperty.call(rows, k)) {
                return unknown('missing-table-row', `table "${args.table}" has no row for ${JSON.stringify(plainOf(key.value))}`);
            }
            let v = rows[k];
            if (args.column !== undefined) {
                if (v === null || typeof v !== 'object' || getPath(v, [args.column]) === undefined) {
                    return unknown('missing-table-row', `table "${args.table}" row ${k} has no column "${args.column}"`);
                }
                v = v[args.column];
            }
            const src = { kind: 'table', table: args.table, origin: table.origin !== undefined ? table.origin : ctx.origin };
            return ok(v, [...key.sources, src]);
        }
        case 'concat': {
            const bad = requireArray(args, 'concat');
            if (bad)
                return bad;
            let s = '';
            const sources = [];
            for (const part of args) {
                const r = evalNode(ctx, part, depth);
                if (r.halt)
                    return r;
                const text = plainOf(r.value);
                if (typeof text !== 'string' && typeof text !== 'number' && typeof text !== 'boolean') {
                    return unknown('not-text', `a concat part is ${JSON.stringify(text)}, which does not read as text`);
                }
                s += String(text);
                sources.push(...r.sources);
            }
            return ok(s, sources);
        }
        /* istanbul ignore next — OPERATIONS gates every op before this switch */
        default:
            return invalid('unknown-operation', `"${op}" is not implemented`);
    }
}
/** `sum`: numbers add exactly; a dice value among them takes the numbers
 * into its bonus, and two dice values merge their pools (07 §3.4). */
function evalSum(ctx, args, depth) {
    const bad = requireArray(args, 'sum');
    if (bad)
        return bad;
    const values = [];
    const sources = [];
    for (const n of args) {
        const r = evalNode(ctx, n, depth);
        if (r.halt)
            return r;
        values.push(r.value);
        sources.push(...r.sources);
    }
    let pools = null;
    let total = 0;
    for (const v of values) {
        const dice = typeof v === 'object' && v !== null ? asDice(v) : null;
        if (dice) {
            pools = mergePools(pools || [], dice.pools);
            total = qAdd(total, dice.bonus);
            continue;
        }
        const num = asNumber(v, 'an operand of sum');
        if (num.halt)
            return { halt: num.halt };
        total = qAdd(total, num.num);
    }
    return ok(pools ? new Dice(pools, total) : total, sources);
}
/** x to the power e, for `pow` and `sqrt`. Exact unless a fractional
 * exponent's root is irrational; then rounded to INEXACT_PLACES and the
 * result carries an `inexact` source, which marks the field (04 §2). */
function power(x, e, op, sources) {
    const [p, q] = toND(e);
    if (q === 1n) {
        // 0, 1 and -1 to any whole power are known without computing it.
        if (x === 1)
            return ok(1, sources);
        if (x === -1)
            return ok(p % 2n === 0n ? 1 : -1, sources);
        if (isZero(x)) {
            if (p < 0n)
                return unknown('division-by-zero', `${op}: zero to a negative power divides by zero`);
            return ok(p === 0n ? 1 : 0, sources);
        }
        if (bitLength(p) > 20)
            return unknown('out-of-range', `${op}: an exponent of ${exactText(e)} is past what a sheet computes`);
        const pn = Number(p);
        if (isZero(x) && pn < 0)
            return unknown('division-by-zero', `${op}: zero to a negative power divides by zero`);
        const v = qPowInt(x, pn);
        if (v === null)
            return unknown('out-of-range', `${op}: the result is past what a sheet computes`);
        return ok(v, sources);
    }
    // A fractional exponent p/q is the q-th root of x^p.
    if (sign(x) < 0) {
        return unknown('not-real', `${op}: ${exactText(x)} has no real root here — declining rather than serving NaN`);
    }
    if (isZero(x))
        return p < 0n ? unknown('division-by-zero', `${op}: zero to a negative power divides by zero`) : ok(0, sources);
    const inexactTag = { kind: 'inexact', op, places: INEXACT_PLACES };
    if (q > BigInt(MAX_ROOT) || bitLength(p) > 20) {
        const f = Math.pow(toNumber(x), toNumber(e));
        if (!Number.isFinite(f))
            return unknown('out-of-range', `${op}: the result is past what a sheet computes`);
        return ok(parseDecimal(f < 1e21 ? f.toFixed(INEXACT_PLACES) : String(f)), [...sources, inexactTag]);
    }
    const base = qPowInt(x, Number(p));
    if (base === null)
        return unknown('out-of-range', `${op}: the result is past what a sheet computes`);
    const root = qRoot(base, Number(q));
    return ok(root.num, root.exact ? sources : [...sources, inexactTag]);
}
/** An object-argument operation's keys: `required` all present, nothing
 * outside `required` + `optional`. */
function exactKeys(args, required, opName, optional = []) {
    for (const k of required) {
        if (args[k] === undefined)
            return invalid('bad-node', `${opName} is missing its "${k}"`);
    }
    const extra = Object.keys(args).filter((k) => !required.includes(k) && !optional.includes(k));
    if (extra.length)
        return invalid('bad-node', `${opName} does not take [${extra.join(', ')}]`);
    return null;
}
function compareValues(op, a, b, sources) {
    if (op === 'eq' || op === 'ne') {
        // Equality is meaningful on same-typed values; numbers compare
        // numerically even when one side is an authored numeric string.
        const an = asNumber(a, 'a comparison operand');
        const bn = asNumber(b, 'a comparison operand');
        let equal;
        if (!an.halt && !bn.halt)
            equal = qCmp(an.num, bn.num) === 0;
        else if (typeof a === typeof b && (typeof a === 'string' || typeof a === 'boolean'))
            equal = a === b;
        else
            return unknown('not-comparable', `${JSON.stringify(plainOf(a))} and ${JSON.stringify(plainOf(b))} cannot be compared`);
        return ok(op === 'eq' ? equal : !equal, sources);
    }
    const an = asNumber(a, 'a comparison operand');
    if (an.halt)
        return { halt: an.halt };
    const bn = asNumber(b, 'a comparison operand');
    if (bn.halt)
        return { halt: bn.halt };
    const c = qCmp(an.num, bn.num);
    const v = op === 'gt' ? c > 0
        : op === 'gte' ? c >= 0
            : op === 'lt' ? c < 0
                : c <= 0;
    return ok(v, sources);
}
function truthiness(v) {
    if (typeof v === 'boolean')
        return ok(v);
    const n = asNumber(v, 'a condition');
    if (!n.halt)
        return ok(!isZero(n.num));
    return unknown('not-a-condition', `${JSON.stringify(plainOf(v))} does not read as a condition`);
}
/** Resolve an each/track source to a list of scope items. Arrays iterate in
 * order; an object map (the build.skills shape, keyed by address) iterates
 * its entries with the key carried as the item's address. */
function iterableFrom(ctx, over, depth) {
    if (typeof over !== 'string')
        return invalid('bad-node', 'each.over is an address string');
    const r = resolveRef(ctx, over, depth);
    if (r.halt)
        return r;
    const v = r.value;
    if (Array.isArray(v)) {
        return ok(v.map((item) => ({ value: item, address: undefined, sources: r.sources })), r.sources);
    }
    if (v !== null && typeof v === 'object') {
        return ok(Object.entries(v).map(([key, item]) => ({ value: item, address: key, sources: r.sources })), r.sources);
    }
    return unknown('not-a-list', `"${over}" did not resolve to something iterable`);
}
/**
 * The rows a rule counts (qa-runs 1378): a class row left with no class on it
 * is a row of the form and nothing else, so it adds no level, no skill points
 * and no save, and a rule reading the rows never declines over it. The rows a
 * sheet shows still come from iterableFrom, the empty one among them. Which
 * rows these are is read from the declaration: the group holding the
 * `class_level` field, and that group's reference field.
 */
function countedRows(ctx, over, depth) {
    const items = iterableFrom(ctx, over, depth);
    if (items.halt)
        return items;
    const path = own(ctx.classRows, over);
    if (path === undefined)
        return items;
    return ok(items.value.filter((item) => getPath(item.value, path)), items.sources);
}
// ---------------------------------------------------------------------------
// Fields.
// ---------------------------------------------------------------------------
/** Evaluate the field a sheet.* reference names, memoized, with cycle
 * refusal. A cycle is a declaration defect: every field on it reports
 * 'dependency-cycle' rather than one arbitrary member winning. */
function sheetFieldValue(ctx, key, depth = 0) {
    const field = own(ctx.fieldsByKey, key);
    if (field === undefined) {
        return invalid('unknown-field', `no field "${key}" is declared on this sheet`);
    }
    if (field.halt)
        return field; // a duplicate-key marker
    if (field.track !== undefined) {
        // A track field is one result PER ROW; there is no single value for a
        // scalar reference to read, and guessing (first row? sum?) would be a
        // silent wrong number. Inside one of its own rows it has one: the row
        // being computed (issue 1506: a weapon's Critical text reads the row's
        // threat, which Improved Critical changes), with that row's modifiers.
        const row = rowOfTrack(ctx, field);
        if (row === null)
            return invalid('track-field-ref', `"${key}" is a track field — it has one value per row, not one value`);
        if (field.kind !== 'derived' || field.rule === undefined)
            return invalid('unknown-field', `"${key}" is not a derived field — inputs are read through the row`);
        const mark = `${key}@row`;
        if (ctx.visiting.has(mark))
            return invalid('dependency-cycle', `field "${key}" depends on itself on this row`);
        ctx.visiting.add(mark);
        const rowCtx = { ...ctx, scope: row, origin: fieldOrigin(ctx, field) };
        const r = evalNode(rowCtx, field.rule, depth + 1);
        const m = r.halt ? r : applyModifiers(rowCtx, field, r);
        ctx.visiting.delete(mark);
        if (m.halt)
            return m;
        return ok(m.value, [{ kind: 'field', key, origin: fieldOrigin(ctx, field) }, ...m.sources]);
    }
    if (field.kind !== 'derived') {
        return invalid('unknown-field', `"${key}" is not a derived field — inputs are read through build.*`);
    }
    if (ctx.visiting.has(key)) {
        return invalid('dependency-cycle', `field "${key}" depends on itself (…→ ${[...ctx.visiting].join(' → ')} → ${key})`);
    }
    // A reference reads the field AS THE SHEET SHOWS IT - its rule's result
    // with its modifiers applied (issue 665). Bull's Strength on the Strength
    // score has to reach the Strength modifier, the melee attack and every
    // skill that reads it, or an effect would change a number and none of its
    // consequences; the epic's pipeline is "the field holds its modified value,
    // everything derived from it recomputes". An OVERRIDE is not read here: a
    // pin wins on display only (§3b) and never feeds a rule.
    const m = modifiedField(ctx, field, depth);
    if (m.halt)
        return m;
    return ok(m.value, [
        { kind: 'field', key, origin: fieldOrigin(ctx, field) },
        ...m.sources,
    ]);
}
/**
 * The field's rule result WITH its modifiers, memoized once per field: the
 * one place a modified value is computed, read by both the sheet.* hop above
 * and the public result below so the two cannot disagree.
 */
function modifiedField(ctx, field, depth = 0) {
    const key = field.key;
    if (!ctx.modified.has(key)) {
        // Each sheet.* hop starts a fresh rule tree (MAX_DEPTH is per tree), so a
        // chain of fields is capped as a whole: by the hops still open and by the
        // rule depth summed along them. Past either, the chain declines
        // max-depth rather than exhausting the stack.
        if (ctx.hops.open >= MAX_HOPS || ctx.hops.depth + depth > MAX_CHAIN_DEPTH) {
            // Refused only for how deep it was reached: noted, so nothing computed
            // from this refusal is remembered, and the field is computed afresh
            // from the top (settleField) - the answer never depends on the order
            // the fields were declared in.
            ctx.hops.refusals += 1;
            if (ctx.hops.refused === null)
                ctx.hops.refused = key;
            return invalid('max-depth', `field "${key}" is reached through a chain of sheet references deeper than a sheet computes — refused rather than recursed`);
        }
        ctx.hops.open += 1;
        ctx.hops.depth += depth + 1;
        ctx.visiting.add(key);
        const refusals = ctx.hops.refusals;
        let r = ctx.memo.get(key);
        const fresh = r === undefined;
        if (fresh) {
            // Evaluated in a CLEAN scope: a sheet.* hop must mean the same thing
            // from inside an each as from outside it.
            r = evalNode({ ...ctx, scope: rowScope(field), origin: fieldOrigin(ctx, field) }, field.rule, 0);
        }
        const m = r.halt ? r : applyModifiers(ctx, field, r);
        ctx.visiting.delete(key);
        ctx.hops.open -= 1;
        ctx.hops.depth -= depth + 1;
        // A result that a hop-depth refusal reached is not this field's answer,
        // only this path's: it is returned, never remembered.
        if (ctx.hops.refusals !== refusals)
            return m;
        if (fresh)
            ctx.memo.set(key, r);
        ctx.modified.set(key, m);
    }
    return ctx.modified.get(key);
}
/**
 * A derived field's rule result, evaluated from the top (no hops open), so
 * that a chain of sheet.* references longer than MAX_HOPS computes: when a
 * field deep in the chain is refused for depth, that field is settled first
 * - from the top, where it has the whole budget - and the one above it is
 * tried again. Each round settles a field never settled before, so this
 * ends, and no round holds more than MAX_HOPS hops on the stack.
 */
function settleField(ctx, field) {
    const work = [field];
    let rounds = 0;
    const limit = 2 * Object.keys(ctx.fieldsByKey).length + 2;
    let last = null;
    while (work.length) {
        const f = work[work.length - 1];
        if (ctx.memo.has(f.key)) {
            last = ctx.memo.get(f.key);
            work.pop();
            continue;
        }
        ctx.hops.refused = null;
        const refusals = ctx.hops.refusals;
        ctx.visiting.add(f.key);
        const r = evalNode({ ...ctx, scope: rowScope(f), origin: fieldOrigin(ctx, f) }, f.rule, 0);
        // Its modified value too, as a sheet.* hop reads it (modifiedField).
        const m = ctx.hops.refusals === refusals && !r.halt ? applyModifiers(ctx, f, r) : r;
        ctx.visiting.delete(f.key);
        const deeper = ctx.hops.refused !== null ? own(ctx.fieldsByKey, ctx.hops.refused) : undefined;
        rounds += 1;
        if (deeper && work.includes(deeper)) {
            // Each field on the list depends on the next; the refused one is back
            // on the list, so these fields are a cycle longer than the hop cap.
            const loop = work.slice(work.indexOf(deeper));
            const cyc = invalid('dependency-cycle', `field "${f.key}" depends on itself (${loop.map((x) => x.key).join(' → ')} → …)`);
            for (const x of loop) {
                ctx.memo.set(x.key, cyc);
                ctx.modified.set(x.key, cyc);
            }
            work.length = work.length - loop.length;
            last = cyc;
            continue;
        }
        if (ctx.hops.refusals === refusals || !deeper || deeper.halt || rounds > limit) {
            // Settled - or it cannot be, and the refusal is its answer this once.
            if (ctx.hops.refusals === refusals) {
                ctx.memo.set(f.key, r);
                ctx.modified.set(f.key, m);
            }
            last = r;
            work.pop();
            if (ctx.hops.refusals !== refusals && work.length)
                return r;
            continue;
        }
        work.push(deeper);
    }
    return last;
}
/** A source saying an optional choice is still unset (qa-runs 363): the
 * number stands, and more may apply once it is made. */
function isPending(src) {
    return src.kind === 'absent' && src.code === 'missing-input';
}
function fieldOrigin(ctx, field) {
    return field.origin !== undefined ? field.origin : ctx.declOrigin;
}
/** One field's full public result from a rule evaluation plus its modifiers
 * and its override. This is where the three states meet, and where the
 * contribution list is assembled. */
function fieldResult(ctx, field, ruleResult, overrideValue) {
    const origin = fieldOrigin(ctx, field);
    const out = { key: field.key };
    if (ruleResult.halt) {
        out.status = ruleResult.halt.status;
        out.reason = ruleResult.halt.reason;
        out.sources = [];
        out.contributions = [];
    }
    else {
        const applied = ctx.modified && ctx.modified.has(field.key) && ctx.modified.get(field.key).ruleValue === ruleResult.value
            ? ctx.modified.get(field.key)
            : applyModifiers(ctx, field, ruleResult);
        if (applied.halt) {
            out.status = applied.halt.status;
            out.reason = applied.halt.reason;
            out.sources = [];
            out.contributions = [];
        }
        else {
            out.status = 'computed';
            Object.assign(out, publicOf(applied.value));
            out.sources = dedupeSources(applied.sources);
            out.contributions = applied.contributions;
            if (out.sources.some((src) => src.kind === 'inexact'))
                out.inexact = true;
            if (out.sources.some(isPending))
                out.provisional = true;
        }
    }
    // The override never overwrites: `value` above stays whatever the engine
    // computed (or the decline stays stated); the pin only wins on `display`.
    return withOverride(ctx, field, out, overrideValue);
}
/** A field's rule result plus its modifiers: value, sources, contributions - or a halt. */
function applyModifiers(ctx, field, ruleResult) {
    const origin = fieldOrigin(ctx, field);
    {
        let value = ruleResult.value;
        let sources = [{ kind: 'rule', origin }, ...ruleResult.sources];
        const contributions = [
            { kind: 'rule', value: publicOf(ruleResult.value).value, origin, sources: dedupeSources(ruleResult.sources) },
        ];
        let halted = null;
        // A modifier's value may be a literal or a rule; the rule is evaluated
        // first so stacking compares numbers, then the stacked list is walked in
        // application order.
        const mine = [];
        for (const m of ctx.modifiers) {
            if (m.field !== field.key)
                continue;
            if (!MODIFIER_MODES.has(m.mode)) {
                halted = invalid('unknown-modifier-mode', `modifier mode "${m.mode}" is not one this evaluator knows — the set is closed`).halt;
                break;
            }
            // A modifier with `where` (issue 1506; feats.md §5) is for some rows
            // of a repeating list only: its rule is read in the scope of the row
            // being computed, and the modifier counts on that row only when it is
            // true. A row it cannot be read on (no weapon linked yet), or a field
            // outside any row, is not one it is for - never a halted field. Its
            // value reads the same row, so "the chosen skill's ranks" can be one.
            const rowScoped = m.where !== undefined;
            if (rowScoped) {
                const w = evalNode({ ...ctx, origin: m.origin }, m.where, 0);
                const t = w.halt ? null : truthiness(w.value);
                if (t === null || t.halt || t.value !== true)
                    continue;
            }
            const r = evalNode({ ...ctx, scope: rowScoped ? ctx.scope : {}, origin: m.origin }, m.value, 0);
            if (r.halt) {
                halted = r.halt;
                break;
            }
            // A `set` to yes or no (issue 1521): a standing effect that gives the
            // character a flag, such as a cybereye's low-light vision. It takes no
            // part in stacking, which compares numbers.
            if (m.mode === 'set' && typeof r.value === 'boolean') {
                mine.push({ ...m, value: r.value, exact: r.value, ruleSources: r.sources });
                continue;
            }
            const num = asNumber(r.value, 'a modifier value');
            if (num.halt) {
                halted = num.halt;
                break;
            }
            // Stacking compares the plain number; the walk applies the exact one.
            mine.push({ ...m, value: toNumber(num.num), exact: num.num, ruleSources: r.sources });
        }
        if (!halted) {
            for (const { m, applied } of stackModifiers(mine, ctx.stacking)) {
                const tag = { kind: 'modifier', mode: m.mode, value: m.value, origin: m.origin,
                    ...(m.label !== undefined ? { label: m.label } : {}),
                    ...(m.bonus_type !== undefined ? { bonus_type: m.bonus_type } : {}),
                    ...(typeof m.note === 'string' ? { note: m.note } : {}),
                    ...(typeof m.position === 'number' ? { position: m.position } : {}) };
                if (!applied) {
                    contributions.push({ ...tag, applied: false, reason: 'stacking' });
                    continue;
                }
                // An `add` onto a dice value lands in its bonus, as `sum` would put
                // it; any other mode on dice declines not-numeric below.
                const dice = m.mode === 'add' && value !== null && typeof value === 'object' ? asDice(value) : null;
                if (dice) {
                    value = new Dice(dice.pools, qAdd(dice.bonus, m.exact));
                }
                else if (m.mode === 'set') {
                    value = m.exact;
                }
                else {
                    const base = asNumber(value, 'the value a modifier applies to');
                    if (base.halt) {
                        halted = base.halt;
                        break;
                    }
                    value = m.mode === 'add' ? qAdd(base.num, m.exact) : qMul(base.num, m.exact);
                }
                const src = { kind: 'modifier', origin: m.origin };
                if (m.label !== undefined)
                    src.label = m.label;
                sources.push(src, ...m.ruleSources);
                contributions.push({ ...tag, applied: true });
            }
        }
        if (halted)
            return { halt: halted, ruleValue: ruleResult.value };
        return { value, sources, contributions, ruleValue: ruleResult.value };
    }
}
/** The override's half of the public result: a pin wins on display only. */
function withOverride(ctx, field, out, overrideValue) {
    if (overrideValue !== undefined) {
        if (field.overridable === true) {
            out.override = { value: overrideValue, applied: true };
            out.display = { from: 'override', value: overrideValue };
        }
        else {
            out.override = { value: overrideValue, applied: false, reason: 'not-overridable' };
        }
    }
    else {
        out.override = null;
    }
    if (!out.display) {
        out.display = out.status === 'computed'
            ? { from: 'computed', value: out.value }
            : { from: 'unknown', reason: out.reason };
    }
    return out;
}
// ---------------------------------------------------------------------------
// The public surface.
// ---------------------------------------------------------------------------
/**
 * Evaluate one rule against data. `env`: { build, content, tables (map or
 * the declaration's array), origin, scope }. Returns { status, value?,
 * reason?, sources } — the same vocabulary evaluateSheet speaks per field.
 */
function evaluateRule(rule, env = {}) {
    const ctx = baseContext({
        declaration: { origin: env.origin, tables: env.tables, content_slots: env.content_slots },
        build: env.build,
        content: env.content,
        modifiers: [],
    });
    ctx.scope = env.scope || {};
    const r = evalNode(ctx, rule, 0);
    if (r.halt)
        return { status: r.halt.status, reason: r.halt.reason, sources: [] };
    const sources = dedupeSources(r.sources);
    return { status: 'computed', ...publicOf(r.value), sources,
        ...(sources.some((src) => src.kind === 'inexact') ? { inexact: true } : {}),
        ...(sources.some(isPending) ? { provisional: true } : {}) };
}
/** Where a sheet keeps its class rows: { 'build.classes': ['ref'] }, the path of the class on a row. */
function classRowsOf(declaration) {
    const out = Object.create(null);
    const fields = declaration && Array.isArray(declaration.fields) ? declaration.fields : [];
    const groups = declaration && Array.isArray(declaration.groups) ? declaration.groups : [];
    const level = fields.find((f) => f && f.purpose === 'class_level');
    if (!level)
        return out;
    for (const g of groups) {
        if (!g || typeof g.over !== 'string' || !Array.isArray(g.fields) || !g.fields.includes(level.key))
            continue;
        const ref = fields.find((f) => f && g.fields.includes(f.key) && f.datatype === 'reference' && typeof f.path === 'string');
        if (ref)
            out[g.over] = ref.path.split('.');
    }
    return out;
}
function baseContext({ declaration, build, content, modifiers, stacking }) {
    const tables = Object.create(null);
    const declared = declaration && declaration.tables;
    if (Array.isArray(declared)) {
        for (const t of declared)
            if (t && typeof t.name === 'string')
                tables[t.name] = t;
    }
    else if (declared && typeof declared === 'object') {
        for (const [name, t] of Object.entries(declared))
            tables[name] = { name, ...(t || {}) };
    }
    const declOrigin = declaration && declaration.origin !== undefined ? declaration.origin : 'base';
    return {
        classRows: classRowsOf(declaration),
        build: build || {},
        content: content || {},
        contentSlots: (declaration && declaration.content_slots) || {},
        tables,
        declOrigin,
        origin: declOrigin,
        scope: {},
        modifiers: modifiers || [],
        stacking: stacking || null,
        fieldsByKey: Object.create(null),
        hops: { open: 0, depth: 0, refusals: 0, refused: null },
        memo: new Map(),
        modified: new Map(),
        visiting: new Set(),
    };
}
/**
 * The evaluation pass: a declaration plus a character's build and overrides
 * (plus resolved content and any layer-shaped modifiers) in, `derived` out.
 *
 * Returns { fields: { key: FieldResult } } — derived fields only, since
 * inputs live in build and notes are never interpreted. A scalar FieldResult
 * is { key, status, value?, reason?, sources, contributions, override,
 * display }; a track FieldResult is { key, track, rows: [ { row, …the same
 * } ] } with an override addressed as "<fieldKey>:<rowKey>".
 */
function evaluateSheet({ declaration, build, overrides, content, modifiers, stacking } = {}) {
    if (declaration === null || typeof declaration !== 'object') {
        throw new TypeError('evaluateSheet needs a declaration object');
    }
    // Accept the full document shape (format 1's sections[].fields[], or
    // format 2's flat fields[] with groups owning their columns) or a flat
    // fields list — the evaluator reads fields and ignores layout, the same
    // split GenericDetail makes for content. Format 2 is read here in the few
    // lines it needs rather than through scripts/mrcs/sheet-format.js, because
    // this module requires nothing: a group's column is a track field.
    let fields = Array.isArray(declaration.fields)
        ? declaration.fields
        : (declaration.sections || []).flatMap((s) => s.fields || []);
    const tracks = Object.create(null);
    if (declaration.format === 2) {
        const columnOf = new Map();
        for (const g of Array.isArray(declaration.groups) ? declaration.groups : []) {
            if (!g || typeof g.key !== 'string' || tracks[g.key] !== undefined)
                continue;
            tracks[g.key] = g;
            for (const k of Array.isArray(g.fields) ? g.fields : []) {
                if (typeof k === 'string' && !columnOf.has(k))
                    columnOf.set(k, g.key);
            }
        }
        fields = fields.map((f) => (f && columnOf.has(f.key) ? { ...f, track: columnOf.get(f.key) } : f));
    }
    for (const t of declaration.format === 2 ? [] : declaration.tracks || []) {
        if (t && typeof t.key === 'string')
            tracks[t.key] = t;
    }
    const orderedTracks = Object.create(null);
    const allGroups = Object.assign(Object.create(null), tracks);
    if (declaration.format === 2) {
        fields = expandFixedGroups(fields, tracks);
        for (const g of Object.values(tracks)) {
            if (g.type === 'ordered_track')
                orderedTracks[g.key] = g;
            if (g.type !== undefined && g.type !== 'repeating_rows')
                delete tracks[g.key];
        }
    }
    // A FIELD'S OWN MODIFIERS (issue 1509): a derived field may declare named
    // parts of its number, `modifiers: [{ label, value, where? }]`, each an
    // untyped add that is its own line in the contributions, as a feat's is -
    // the sheet's two-weapon penalty on a weapon row's attack. They join the
    // modifier list first, under the field's origin; `where` and `value` are
    // read as a feat's are, so a part counts only on the rows it is for.
    const declOrigin = declaration.origin !== undefined ? declaration.origin : 'base';
    const declared = [];
    for (const f of fields) {
        if (!f || typeof f.key !== 'string' || f.kind !== 'derived' || !Array.isArray(f.modifiers))
            continue;
        for (const m of f.modifiers) {
            if (!m || typeof m !== 'object')
                continue;
            declared.push({ field: f.key, mode: 'add', value: m.value, origin: f.origin !== undefined ? f.origin : declOrigin,
                ...(m.where !== undefined ? { where: m.where } : {}), ...(typeof m.label === 'string' ? { label: m.label } : {}) });
        }
    }
    const ctx = baseContext({ declaration, build, content, modifiers: declared.length ? [...declared, ...(modifiers || [])] : modifiers, stacking });
    ctx.orderedTracks = orderedTracks;
    ctx.tracks = tracks;
    const ovr = overrides && typeof overrides === 'object' ? overrides : {};
    const pin = (k) => own(ovr, k);
    for (const f of fields) {
        if (!f || typeof f.key !== 'string')
            continue;
        if (ctx.fieldsByKey[f.key] !== undefined) {
            // Two declarations of one key: refusing beats one silently winning.
            ctx.fieldsByKey[f.key] = invalid('duplicate-key', `field "${f.key}" is declared more than once`);
            continue;
        }
        ctx.fieldsByKey[f.key] = f;
    }
    const out = { fields: {} };
    for (const f of fields) {
        if (!f || typeof f.key !== 'string' || f.kind !== 'derived')
            continue;
        const marker = ctx.fieldsByKey[f.key];
        if (marker && marker.halt) {
            out.fields[f.key] = fieldResult(ctx, f, marker, undefined);
            continue;
        }
        if (f.track !== undefined) {
            out.fields[f.key] = trackFieldResult(ctx, f, own(tracks, f.track), pin);
        }
        else {
            // Route through the same memoized path sheet.* uses, so a field is
            // never computed twice and cycles are refused identically.
            const r = probeField(ctx, f);
            out.fields[f.key] = fieldResult(ctx, f, r, pin(f.key));
        }
    }
    // An ordered track answers under its own key (issue 925): its penalty as
    // the value, with its size, filled, remaining and levels beside it.
    for (const key of Object.keys(orderedTracks)) {
        if (out.fields[key] === undefined)
            out.fields[key] = orderedTrackResult(ctx, key);
    }
    // Conditions and messages (issue 929): each `when` is a rule read over the
    // same fields, answered true, false or null (it could not be worked out).
    // Present only when the declaration carries them, so every older sheet's
    // answer keeps its shape.
    for (const list of ['conditions', 'messages']) {
        if (!Array.isArray(declaration[list]))
            continue;
        out[list] = {};
        for (const item of declaration[list]) {
            if (!item || typeof item.key !== 'string' || item.when === undefined)
                continue;
            out[list][item.key] = ruleTruth(ctx, item.when);
        }
    }
    // Rule checks (qa-runs 365): the system's rules a build can break, as data.
    // Present only when the declaration carries them.
    if (Array.isArray(declaration.checks))
        out.checks = ruleChecks(ctx, declaration.checks, allGroups);
    // Budgets and priority assignments (issue 932): present only when the
    // declaration carries one (a track's capacity is one), so an older sheet's
    // answer keeps its shape.
    const repeating = Object.create(null);
    for (const [k, g] of Object.entries(allGroups))
        if (g.type === undefined || g.type === 'repeating_rows')
            repeating[k] = g;
    const hasBudgets = (Array.isArray(declaration.budgets) && declaration.budgets.length)
        || Object.values(repeating).some((g) => g.capacity !== undefined);
    if (hasBudgets || (Array.isArray(declaration.priorities) && declaration.priorities.length)) {
        const { budgets, priorities } = budgetResults(ctx, declaration, repeating);
        if (hasBudgets)
            out.budgets = budgets;
        if (Object.keys(priorities).length)
            out.priorities = priorities;
    }
    return out;
}
/**
 * RULE CHECKS (qa-runs 365). Each check is declared by the sheet:
 *   { key, section, rows?, over?, as?, when, say, warning? }
 * `rows` runs it once per row of a repeating group (the row bound as the
 * group's `as`); `over` (an address, read in that scope) runs it once per item
 * of a list or set, bound as `as`. `when` is a rule that is TRUE when the build
 * breaks the rule; `say` is a rule giving the words ("Power Attack needs Str 13
 * (you have 12)"). A check that cannot be worked out (null) reports nothing: a
 * check never guesses a problem. Nothing here knows any game; the words, the
 * rules and the sections are all the declaration's.
 * Answers a list of { key, section, message, warning?, row? }.
 */
const MAX_CHECK_RESULTS = 200;
function ruleChecks(ctx, checks, groups) {
    const found = [];
    const once = (check, scope, row) => {
        if (found.length >= MAX_CHECK_RESULTS)
            return;
        const c = { ...ctx, scope, origin: ctx.declOrigin };
        const w = evalNode(c, check.when, 0);
        if (!w || w.halt)
            return;
        const t = truthiness(w.value);
        if (t.halt || !t.value)
            return;
        const s = check.say === undefined ? null : evalNode(c, check.say, 0);
        const words = s && !s.halt ? plainOf(s.value) : null;
        const message = typeof words === 'string' || typeof words === 'number' ? String(words)
            : (typeof check.label === 'string' ? check.label : check.key);
        found.push({ key: check.key, section: typeof check.section === 'string' ? check.section : null,
            message, ...(check.warning === true ? { warning: true } : {}), ...(row !== undefined ? { row } : {}) });
    };
    const perItem = (check, scope, row) => {
        if (typeof check.over !== 'string') {
            once(check, scope, row);
            return;
        }
        const items = countedRows({ ...ctx, scope }, check.over, 0);
        if (items.halt)
            return;
        const as = typeof check.as === 'string' && check.as ? check.as : 'item';
        for (const item of items.value)
            once(check, { ...scope, [as]: item }, row);
    };
    for (const check of checks) {
        if (!check || typeof check.key !== 'string' || check.when === undefined)
            continue;
        if (typeof check.rows === 'string') {
            const g = own(groups, check.rows);
            if (!g || typeof g.over !== 'string')
                continue;
            const rows = iterableFrom(ctx, g.over, 0);
            if (rows.halt)
                continue;
            const as = typeof g.as === 'string' && g.as ? g.as : g.key;
            rows.value.forEach((item, i) => perItem(check, { [as]: item }, i));
        }
        else {
            perItem(check, {}, undefined);
        }
    }
    return found;
}
/** A condition's rule as true, false or null: null when it declines. */
function ruleTruth(ctx, rule) {
    const r = evalNode({ ...ctx, scope: {}, origin: 'base' }, rule, 0);
    if (!r || r.halt)
        return null;
    const t = truthiness(r.value);
    return t.halt ? null : t.value;
}
/** A value as a condition reads it: true, false, or null when it does not
 * read as one ("0" and 0 are false; "false" is not a condition). For a
 * caller holding a published field value, such as a creation step's `when`. */
function isTrue(value) {
    if (value === undefined || value === null)
        return null;
    const t = truthiness(value);
    return t.halt ? null : t.value;
}
// ---------------------------------------------------------------------------
// Group types (issue 925, 04 §1). The fixed shapes - a named set, fixed
// slots, a grid, a block - EXPAND: each row by each column is an ordinary
// scalar field keyed `<row>_<column>`, `{row}` in its rule, path and label
// replaced, so it computes, is read (sheet.<row>_<column>) and is modified
// exactly as any field. This is scripts/mrcs/sheet-format.js `expandedFields`
// in the few lines this module needs, since it requires nothing; a test holds
// the two to the same keys. An ordered track is computed here: its size (a
// fixed list of levels, or a rule), each level's value, and from the stored
// boxes the filled count, what remains and the penalty.
// ---------------------------------------------------------------------------
const EXPANDING = ['named_set', 'fixed_slots', 'grid', 'block'];
const TRACK_OUTPUTS = ['penalty', 'filled', 'remaining', 'size'];
const MAX_TRACK_BOXES = 50;
function withRow(value, to) {
    if (typeof value === 'string')
        return value.split('{row}').join(to);
    if (Array.isArray(value))
        return value.map((v) => withRow(v, to));
    if (value !== null && typeof value === 'object') {
        const out = {};
        for (const [k, v] of Object.entries(value))
            out[k] = withRow(v, to);
        return out;
    }
    return value;
}
function fixedRows(g) {
    if (g.type === 'block') {
        const n = Number.isInteger(g.count) && g.count >= 1 && g.count <= 20 ? g.count : 0;
        return Array.from({ length: n }, (_, i) => ({ key: `${g.key}${i + 1}`, label: `${g.label || g.key} ${i + 1}`, value: i + 1 }));
    }
    const seen = new Set();
    return (Array.isArray(g.rows) ? g.rows : [])
        .filter((r) => r && typeof r === 'object' && typeof r.key === 'string' && !seen.has(r.key) && seen.add(r.key));
}
function expandFixedGroups(fields, groups) {
    const byKey = new Map(fields.filter((f) => f && typeof f.key === 'string').map((f) => [f.key, f]));
    const out = [];
    const done = new Set();
    for (const f of fields) {
        const g = f && f.track !== undefined ? own(groups, f.track) : undefined;
        if (!g || !EXPANDING.includes(g.type)) {
            out.push(f);
            continue;
        }
        if (done.has(g.key))
            continue;
        done.add(g.key);
        const base = typeof g.over === 'string' && g.over.startsWith('build.') ? g.over.slice(6) : null;
        const as = typeof g.as === 'string' && g.as ? g.as : g.key;
        const disabled = g.type === 'grid' && Array.isArray(g.disabled) ? g.disabled : [];
        for (const row of fixedRows(g)) {
            for (const k of Array.isArray(g.fields) ? g.fields : []) {
                const col = byKey.get(k);
                if (!col || disabled.some((d) => d && d.row === row.key && d.column === k))
                    continue;
                const { key: _k, track: _t, path, rule, ...rest } = col;
                const cell = { ...rest, key: `${row.key}_${k}`, group: g.key, row: row.key, column: k, as, row_value: row.value,
                    row_label: typeof row.label === 'string' ? row.label : row.key };
                if (typeof path === 'string')
                    cell.path = base === null ? withRow(path, row.key) : `${base}.${row.key}.${withRow(path, row.key)}`;
                if (rule !== undefined)
                    cell.rule = withRow(rule, row.key);
                out.push(cell);
            }
        }
    }
    return out;
}
/** A track field's own row in the scope being computed, as a scope of that
 * row alone; null outside its rows. */
function rowOfTrack(ctx, field) {
    const g = ctx.tracks ? own(ctx.tracks, field.track) : undefined;
    if (!g)
        return null;
    const as = typeof g.as === 'string' && g.as ? g.as : g.key;
    const item = own(ctx.scope, as);
    return item === undefined ? null : { [as]: item };
}
/** The scope a field's rule runs in: a fixed group's cell has its row bound. */
function rowScope(field) {
    if (field.group === undefined || typeof field.as !== 'string')
        return {};
    const value = { key: field.row };
    if (field.row_value !== undefined)
        value.value = field.row_value;
    if (field.row_label !== undefined)
        value.label = field.row_label;
    return { [field.as]: { value, address: field.row, sources: [] } };
}
/** The whole answer of one ordered track, memoized. */
function orderedTrack(ctx, key) {
    const memoKey = `group:${key}`;
    if (ctx.memo.has(memoKey))
        return ctx.memo.get(memoKey);
    if (ctx.visiting.has(memoKey)) {
        return invalid('dependency-cycle', `the ordered track "${key}" depends on itself`);
    }
    ctx.visiting.add(memoKey);
    const refusals = ctx.hops.refusals;
    const r = computeOrderedTrack(ctx, ctx.orderedTracks[key]);
    ctx.visiting.delete(memoKey);
    // Not remembered when a hop-depth refusal reached it (modifiedField).
    if (ctx.hops.refusals === refusals)
        ctx.memo.set(memoKey, r);
    return r;
}
function computeOrderedTrack(ctx, g) {
    const sources = [];
    let levels;
    if (Array.isArray(g.levels)) {
        levels = g.levels.map((l) => ({ ...(l && typeof l.label === 'string' ? { label: l.label } : {}),
            value: l && typeof l.value === 'number' ? numFromJs(l.value) : 0 }));
    }
    else {
        const size = evalNode({ ...ctx, scope: {} }, g.size, 0);
        if (size.halt)
            return size;
        const n = asNumber(size.value, 'an ordered track size');
        if (n.halt)
            return n;
        const count = toNumber(qFloor(n.num));
        if (!(count >= 0) || count > MAX_TRACK_BOXES) {
            // A negative size from a character's value (a stat drained below 0)
            // is the character's state, so the size is unknown; a size past the
            // cap, or a negative one from the declaration alone, is a sheet defect.
            const fromInput = count < 0 && size.sources.some((src) => src.kind === 'input');
            return (fromInput ? unknown : invalid)('out-of-range', `an ordered track has 0 to ${MAX_TRACK_BOXES} boxes; this one computed ${count}`);
        }
        sources.push(...size.sources);
        const as = typeof g.as === 'string' && g.as ? g.as : 'level';
        levels = [];
        for (let i = 1; i <= count; i += 1) {
            if (g.level_value === undefined) {
                levels.push({ value: 0 });
                continue;
            }
            const v = evalNode({ ...ctx, scope: { [as]: { value: { index: i, size: count }, address: i, sources: [] } } }, g.level_value, 0);
            if (v.halt)
                return v;
            const num = asNumber(v.value, 'a level value');
            if (num.halt)
                return num;
            sources.push(...v.sources);
            levels.push({ value: num.num });
        }
    }
    const stored = getPath(ctx.build, String(g.path || '').split('.'));
    let filled = 0;
    let deepest = 0;
    const marks = Array.isArray(g.marks) ? g.marks : null;
    if (stored === undefined || stored === null) {
        // An empty track is empty, not unknown - as an absent list is (sheetBuild).
    }
    else if (Array.isArray(stored)) {
        // A stored value that no longer fits the track - a release dropped a
        // mark or a level, a computed size shrank - is read, not refused (a save
        // only refuses what it changes, sheetBuild.checkGroupValues): boxes past
        // the size are not counted, a mark no longer declared is an empty box,
        // and with no marks declared at all any non-empty box is filled.
        stored.forEach((m, i) => {
            const on = marks ? (typeof m === 'string' && marks.includes(m)) : (m !== null && m !== undefined && m !== false && m !== '');
            if (on && i < levels.length) {
                filled += 1;
                deepest = i + 1;
            }
        });
    }
    else {
        const n = asNumber(stored, `the ordered track "${g.key}"`);
        if (n.halt)
            return n;
        filled = Math.max(0, Math.min(levels.length, Math.floor(toNumber(n.num))));
        deepest = filled;
    }
    sources.push({ kind: 'input', path: `build.${g.path}`, origin: 'player' });
    const penalty = deepest ? levels[deepest - 1].value : 0;
    return ok({ size: levels.length, filled, remaining: levels.length - filled, penalty, levels }, sources);
}
function trackOutput(ctx, key, output) {
    if (!TRACK_OUTPUTS.includes(output)) {
        return invalid('bad-node', `an ordered track answers ${TRACK_OUTPUTS.join(', ')}, not "${output}"`);
    }
    const r = orderedTrack(ctx, key);
    if (r.halt)
        return r;
    return ok(r.value[output], [{ kind: 'group', key, output }, ...dedupeSources(r.sources)]);
}
function orderedTrackResult(ctx, key) {
    const r = orderedTrack(ctx, key);
    if (r.halt)
        return { key, group: 'ordered_track', status: r.halt.status, reason: r.halt.reason, sources: [] };
    const t = r.value;
    const pub = (x) => toNumber(x);
    return {
        key,
        group: 'ordered_track',
        status: 'computed',
        value: pub(t.penalty),
        penalty: pub(t.penalty),
        size: t.size,
        filled: t.filled,
        remaining: t.remaining,
        levels: t.levels.map((l) => ({ ...l, value: pub(l.value) })),
        sources: dedupeSources(r.sources),
    };
}
function probeField(ctx, field) {
    if (field.rule === undefined)
        return invalid('bad-node', `field "${field.key}" declares no rule`);
    if (ctx.visiting.has(field.key)) {
        return invalid('dependency-cycle', `field "${field.key}" depends on itself`);
    }
    if (!ctx.memo.has(field.key))
        return settleField(ctx, field);
    return ctx.memo.get(field.key);
}
function trackFieldResult(ctx, field, track, overrides) {
    if (track === undefined) {
        return { key: field.key, track: field.track, status: 'invalid',
            reason: { code: 'unknown-track', message: `the declaration carries no track named "${field.track}"` },
            rows: [] };
    }
    if (field.rule === undefined) {
        return { key: field.key, track: field.track, status: 'invalid',
            reason: { code: 'bad-node', message: `field "${field.key}" declares no rule` }, rows: [] };
    }
    const as = typeof track.as === 'string' && track.as ? track.as : track.key;
    const items = iterableFrom(ctx, track.over, 0);
    if (items.halt) {
        return { key: field.key, track: field.track, status: items.halt.status, reason: items.halt.reason, rows: [] };
    }
    const rows = [];
    for (const [i, item] of items.value.entries()) {
        const rowKey = item.address !== undefined ? item.address : i;
        const rowCtx = { ...ctx, scope: { [as]: item }, origin: fieldOrigin(ctx, field) };
        const r = evalNode(rowCtx, field.rule, 0);
        const res = fieldResult(rowCtx, field, r, overrides(`${field.key}:${rowKey}`));
        delete res.key;
        rows.push({ row: rowKey, ...res });
    }
    return { key: field.key, track: field.track, status: 'computed', rows };
}
// ---------------------------------------------------------------------------
// Budgets (issue 932, #871 Part 7; 04-sheet-declaration.md §11). A budget is
// a named pool of points spent while building or advancing a character: its
// pool (fixed, a rule, or a priority assignment's value for one option), what
// spends from it (input fields, or the rows of a repeating group), what each
// costs (per point, from a table, or a rule of the value), when it applies,
// the floor and ceiling of each thing it spends on, and whether breaking it
// warns or blocks. A track's `capacity` (#635) is the budget "one point per
// row" and is answered here as one, so a capacity and a budget are one
// mechanism. Everything exact; published as plain numbers.
// ---------------------------------------------------------------------------
const BUDGET_PHASES = ['creation', 'advancement', 'both'];
/** The most rating steps a cost by steps prices (issue 1529). */
const MAX_COST_STEPS = 200;
/** Whether the character is still being created: until its build says
 * `creation_complete: true`. */
function inCreation(build) {
    return !(build && build.creation_complete === true);
}
/** Every budget the declaration carries, a group's capacity included. */
function budgetsOf(declaration, groups) {
    const declared = (Array.isArray(declaration.budgets) ? declaration.budgets : [])
        .filter((b) => b && typeof b === 'object' && typeof b.key === 'string');
    const out = [];
    const seen = new Set();
    for (const b of declared) {
        if (seen.has(b.key))
            continue;
        seen.add(b.key);
        out.push(b);
    }
    for (const g of Object.values(groups)) {
        if (!g || g.capacity === undefined || seen.has(g.key))
            continue;
        if (g.type !== undefined && g.type !== 'repeating_rows')
            continue;
        seen.add(g.key);
        out.push({ key: g.key, ...(g.label !== undefined ? { label: g.label } : {}), pool: { rule: g.capacity }, spends: [{ rows: g.key }] });
    }
    return out;
}
/** Each priority assignment's stored order, checked: each option used once. */
function priorityResults(ctx, declaration) {
    const out = {};
    for (const p of Array.isArray(declaration.priorities) ? declaration.priorities : []) {
        if (!p || typeof p.key !== 'string' || own(out, p.key))
            continue;
        const options = (Array.isArray(p.options) ? p.options : []).map((o) => (o && typeof o === 'object' ? o.key : o)).filter((k) => typeof k === 'string');
        const values = Array.isArray(p.values) ? p.values : [];
        const stored = getPath(ctx.build, ['priorities', p.key]);
        const order = Array.isArray(stored) ? stored.filter((k) => typeof k === 'string') : [];
        const assigned = Object.create(null);
        const violations = [];
        const used = new Set();
        order.forEach((opt, i) => {
            if (!options.includes(opt)) {
                violations.push({ kind: 'unknown_option', option: opt });
                return;
            }
            if (used.has(opt)) {
                violations.push({ kind: 'repeated', option: opt });
                return;
            }
            used.add(opt);
            if (i < values.length)
                assigned[opt] = values[i];
        });
        out[p.key] = { key: p.key, order, assigned: { ...assigned }, complete: violations.length === 0 && options.every((o) => used.has(o)), violations };
    }
    return out;
}
function budgetNumber(ctx, node, scope, what) {
    if (node === undefined)
        return { value: undefined };
    // A budget kept per row of a list (`per`, qa-runs 390) reads with that row bound.
    const r = evalNode({ ...ctx, scope: ctx.perScope ? { ...ctx.perScope, ...scope } : scope, origin: ctx.declOrigin }, node, 0);
    if (r.halt)
        return r;
    const n = asNumber(r.value, what);
    if (n.halt)
        return n;
    return { value: n.num };
}
function budgetPool(ctx, b, priorities) {
    const pool = b.pool && typeof b.pool === 'object' ? b.pool : {};
    if (pool.fixed !== undefined) {
        const n = asNumber(pool.fixed, 'a fixed pool');
        return n.halt ? n : { value: n.num };
    }
    if (pool.rule !== undefined)
        return budgetNumber(ctx, pool.rule, {}, 'a pool');
    if (typeof pool.priority === 'string') {
        const p = own(priorities, pool.priority);
        if (!p)
            return invalid('unknown-priority', `no priority assignment named "${pool.priority}"`);
        if (!Object.prototype.hasOwnProperty.call(p.assigned, pool.option)) {
            return unknown('missing-input', `"${pool.option}" has no place in the ${pool.priority} order yet`);
        }
        let v = p.assigned[pool.option];
        // A pool read from content (issue 1520; docs/MRCS/shadowrun-3.md §3.5):
        // the place's value names an entry of `family` by its slug (the letter
        // "B" is `priority/b`), and the pool is that entry's `attribute`, so the
        // priority numbers have one home, the content the reference pages show.
        if (pool.content && typeof pool.content === 'object') {
            const family = pool.content.family;
            const attribute = pool.content.attribute;
            if (typeof family !== 'string' || typeof attribute !== 'string') {
                return invalid('bad-node', 'a pool read from content is { family, attribute }');
            }
            const r = contentAttr(ctx, `${family}/${String(v).toLowerCase()}`, attribute.split('.'));
            if (r.halt)
                return r;
            v = r.value;
        }
        else if (typeof pool.table === 'string') {
            const t = own(ctx.tables, pool.table);
            if (!t)
                return invalid('unknown-table', `the declaration carries no table named "${pool.table}"`);
            const rows = t.rows || {};
            if (!Object.prototype.hasOwnProperty.call(rows, String(v))) {
                return unknown('missing-table-row', `table "${pool.table}" has no row for ${JSON.stringify(v)}`);
            }
            v = rows[String(v)];
        }
        const n = asNumber(v, 'a priority value');
        return n.halt ? n : { value: n.num };
    }
    return invalid('bad-node', 'a pool is fixed, a rule or a priority');
}
/** The things one spend entry spends on: [{ key, field, row?, value, after, scope }]. */
function budgetTargets(ctx, spend, groups) {
    if (typeof spend.field === 'string') {
        const f = own(ctx.fieldsByKey, spend.field);
        let value;
        let derived;
        if (f && !f.halt && f.kind === 'input' && typeof f.path === 'string') {
            value = { ref: `build.${f.path}` };
        }
        else {
            value = { ref: `sheet.${spend.field}` };
            // A computed field is spent on as its rule gives it, before any named
            // modifier (§11): the cost and a 'before' limit read that value.
            if (f && !f.halt && f.kind === 'derived' && f.track === undefined)
                derived = f;
        }
        return [{ key: spend.field, field: spend.field, value, derived, scope: {} }];
    }
    const g = own(groups, spend.rows);
    if (!g)
        return { halt: invalid('unknown-track', `no group named "${spend.rows}"`).halt };
    const as = typeof g.as === 'string' && g.as ? g.as : g.key;
    const items = iterableFrom(ctx, g.over, 0);
    let list = [];
    if (items.halt) {
        if (!(items.halt.reason && items.halt.reason.code === 'missing-input'))
            return items;
    }
    else {
        list = items.value;
    }
    const col = typeof spend.column === 'string' ? own(ctx.fieldsByKey, spend.column) : undefined;
    // A computed column (issue 1520; shadowrun-3.md §3.5): the row's own
    // answer for it (a gear row's price times its quantity), read on the row
    // as a column of the same list reads it.
    const computed = col && !col.halt && col.kind === 'derived' && col.track === spend.rows;
    // A row that chooses nothing yet is not a choice (qa-runs 1186): when a
    // spend counts rows (no column) and the list declares reference inputs (a
    // feat row's Feat), a row with none of them filled costs nothing, so an
    // empty "Add" row neither fills nor overfills "N of M chosen".
    const refCols = col === undefined
        ? Object.values(ctx.fieldsByKey).filter((f) => f && !f.halt && f.track === spend.rows
            && f.kind === 'input' && f.datatype === 'reference' && typeof f.path === 'string')
        : [];
    const chosen = (item) => refCols.some((f) => {
        const v = item.value && typeof item.value === 'object' ? getPath(item.value, f.path.split('.')) : undefined;
        return v !== undefined && v !== null && v !== '';
    });
    return list.map((item, i) => [item, i]).filter(([item]) => !refCols.length || chosen(item)).map(([item, i]) => {
        const row = item.address !== undefined ? item.address : i;
        let value = 1;
        if (computed)
            value = { ref: `sheet.${spend.column}` };
        else if (col && !col.halt && typeof col.path === 'string')
            value = { ref: `${as}.${col.path}` };
        return {
            key: `${spend.rows}:${row}`,
            field: typeof spend.column === 'string' ? spend.column : spend.rows,
            row,
            value,
            scope: { [as]: item },
        };
    });
}
/** A computed field's value before its modifiers: its rule's result, read
 * through the same memoized path (cycles and depth refused the same way). */
function unmodifiedValue(ctx, field, what) {
    const m = sheetFieldValue(ctx, field.key);
    const r = ctx.memo.get(field.key);
    if (!r)
        return m;
    if (r.halt)
        return r;
    const n = asNumber(r.value, what);
    if (n.halt)
        return n;
    return { value: n.num };
}
function spendCost(ctx, cost, value, base, scope, tables) {
    const c = cost && typeof cost === 'object' ? cost : { per_point: 1 };
    let raw;
    if (typeof c.table === 'string') {
        const table = own(tables, c.table);
        const rows = (table && table.rows) || {};
        const price = (v) => {
            const k = String(toNumber(v));
            if (!Object.prototype.hasOwnProperty.call(rows, k))
                return null;
            const n = asNumber(rows[k], 'a cost');
            return n.halt ? null : n.num;
        };
        const at = price(value);
        if (at === null)
            return { none: true };
        const from = base === undefined ? 0 : price(base);
        // A base the table has no row for is not free: the cost is not known.
        if (from === null)
            return { none: true };
        raw = qSub(at, from);
    }
    else if (c.rule !== undefined) {
        const point = { value: { value, base: base === undefined ? 0 : base }, address: 'point', sources: [] };
        const r = budgetNumber(ctx, c.rule, { ...scope, point }, 'a cost');
        if (r.halt)
            return r;
        raw = r.value;
    }
    else if (c.step !== undefined) {
        // A cost a step at a time (issue 1529; docs/MRCS/shadowrun-3.md §2.5): the
        // rule prices each rating from the base up to the value, `point.value` the
        // step's new rating and `point.base` the one before, and the steps add up.
        // A value under its base is the same steps taken back. Whole ratings only.
        const from = base === undefined ? 0 : base;
        if (qCmp(qFloor(value), value) !== 0 || qCmp(qFloor(from), from) !== 0)
            return invalid('bad-node', 'a cost by steps prices whole ratings');
        const down = qCmp(value, from) < 0;
        const lo = toNumber(down ? value : from);
        const hi = toNumber(down ? from : value);
        if (hi - lo > MAX_COST_STEPS)
            return invalid('too-many-steps', `a cost by steps prices at most ${MAX_COST_STEPS} steps`);
        raw = 0;
        for (let r = lo + 1; r <= hi; r += 1) {
            const point = { value: { value: r, base: r - 1 }, address: 'point', sources: [] };
            const n = budgetNumber(ctx, c.step, { ...scope, point }, 'a cost');
            if (n.halt)
                return n;
            raw = qAdd(raw, n.value);
        }
        if (down)
            raw = qNeg(raw);
    }
    else {
        const per = asNumber(c.per_point === undefined ? 1 : c.per_point, 'a cost per point');
        if (per.halt)
            return per;
        raw = qMul(qSub(value, base === undefined ? 0 : base), per.num);
    }
    if (c.times && typeof c.times === 'object') {
        // A multiplier whose condition cannot be worked out (is this a class
        // skill?) leaves the cost unknown rather than single.
        const w = evalNode({ ...ctx, scope, origin: ctx.declOrigin }, c.times.when, 0);
        if (w.halt)
            return w;
        const t = truthiness(w.value);
        if (t.halt)
            return t;
        if (t.value) {
            const by = asNumber(c.times.by, 'a cost multiplier');
            if (by.halt)
                return by;
            raw = qMul(raw, by.num);
        }
    }
    return { value: raw };
}
function evaluateBudget(ctx, b, groups, priorities) {
    const phase = BUDGET_PHASES.includes(b.phase) ? b.phase : 'both';
    const creating = inCreation(ctx.build);
    const applies = phase === 'both' || (phase === 'creation') === creating;
    const enforcement = b.enforcement === 'block' ? 'block' : 'warn';
    const head = { key: b.key, label: typeof b.label === 'string' ? b.label : b.key, phase, applies, enforcement };
    if (b.exact === true)
        head.exact = true;
    // How the sheet words it (qa-runs 390): "known" says "Known 3 of 4".
    if (typeof b.words === 'string')
        head.words = b.words;
    const pool = budgetPool(ctx, b, priorities);
    const limitsOf = (spend) => ({ ...(b.limits && typeof b.limits === 'object' ? b.limits : {}),
        ...(spend.limits && typeof spend.limits === 'object' ? spend.limits : {}) });
    const targets = [];
    const violations = [];
    let spent = 0;
    let spentKnown = true;
    for (const spend of Array.isArray(b.spends) ? b.spends : []) {
        if (!spend || typeof spend !== 'object')
            continue;
        const list = budgetTargets(ctx, spend, groups);
        if (list.halt)
            return { ...head, status: list.halt.status, reason: list.halt.reason, pool: null, spent: null, remaining: null, targets: [], violations: [] };
        const limits = limitsOf(spend);
        for (const t of list) {
            // `where` (qa-runs 390): only the rows it holds true for spend here - a
            // spell row prepares against its own casting class's slots.
            if (spend.where !== undefined) {
                const w = evalNode({ ...ctx, scope: { ...(ctx.perScope || {}), ...t.scope }, origin: ctx.declOrigin }, spend.where, 0);
                if (w.halt)
                    continue;
                const truth = truthiness(w.value);
                if (truth.halt || !truth.value)
                    continue;
            }
            const out = { key: t.key, field: t.field, ...(t.row !== undefined ? { row: t.row } : {}) };
            const v = t.derived ? unmodifiedValue(ctx, t.derived, `"${t.key}"`) : budgetNumber(ctx, t.value, t.scope, `"${t.key}"`);
            if (v.halt) {
                out.status = v.halt.status;
                out.reason = v.halt.reason;
                targets.push(out);
                spentKnown = false;
                continue;
            }
            // A base that cannot be worked out (the rating at creation, not yet
            // recorded) makes the cost unknown - never a base of 0.
            const base = budgetNumber(ctx, spend.base, t.scope, 'a base');
            const cost = base.halt ? base
                : spendCost(ctx, spend.cost !== undefined ? spend.cost : b.cost, v.value, base.value, t.scope, ctx.tables);
            out.status = 'computed';
            out.value = toNumber(v.value);
            const tag = { target: t.key, field: t.field, ...(t.row !== undefined ? { row: t.row } : {}) };
            const check = limits.check === 'after' ? 'after' : 'before';
            let checked = v.value;
            if (check === 'after') {
                // Pass H requires an `after` field; without one there is no value
                // after modifiers to check, and the before value is not it.
                const a = typeof spend.after === 'string'
                    ? budgetNumber(ctx, { ref: `sheet.${spend.after}` }, {}, 'a value after modifiers') : { halt: true };
                checked = a.halt ? null : a.value;
            }
            if (checked !== null) {
                const min = budgetNumber(ctx, limits.min, t.scope, 'a floor');
                const max = budgetNumber(ctx, limits.max, t.scope, 'a ceiling');
                if (!min.halt && min.value !== undefined && qCmp(checked, min.value) < 0) {
                    violations.push({ kind: 'below_min', ...tag, value: toNumber(checked), limit: toNumber(min.value), check });
                }
                if (!max.halt && max.value !== undefined && qCmp(checked, max.value) > 0) {
                    violations.push({ kind: 'above_max', ...tag, value: toNumber(checked), limit: toNumber(max.value), check });
                }
            }
            if (cost.none) {
                out.cost = null;
                violations.push({ kind: 'no_cost', ...tag, value: out.value });
            }
            else if (cost.halt) {
                out.cost = null;
                spentKnown = false;
            }
            else {
                const c = spend.refund === true ? qNeg(cost.value) : cost.value;
                out.cost = toNumber(c);
                spent = qAdd(spent, c);
            }
            targets.push(out);
        }
    }
    const result = { ...head, targets };
    if (pool.halt) {
        Object.assign(result, { status: pool.halt.status, reason: pool.halt.reason, pool: null,
            spent: spentKnown ? toNumber(spent) : null, remaining: null });
    }
    else {
        Object.assign(result, { status: 'computed', pool: toNumber(pool.value),
            spent: spentKnown ? toNumber(spent) : null, remaining: spentKnown ? toNumber(qSub(pool.value, spent)) : null });
        if (spentKnown && qCmp(spent, pool.value) > 0)
            violations.unshift({ kind: 'over', spent: result.spent, pool: result.pool });
        if (spentKnown && b.exact === true && qCmp(spent, pool.value) < 0)
            violations.unshift({ kind: 'under', spent: result.spent, pool: result.pool });
    }
    // A limit is a fact about the value, but only while the budget applies.
    result.violations = applies ? violations : [];
    return result;
}
/** Whether a budget is kept at all (`when`, qa-runs 390): a rule, on the row
 * for a budget kept per row; one that declines keeps no budget. */
function budgetKept(ctx, b, scope) {
    if (b.when === undefined)
        return true;
    const w = evalNode({ ...ctx, scope, origin: ctx.declOrigin }, b.when, 0);
    if (w.halt)
        return false;
    const t = truthiness(w.value);
    return !t.halt && Boolean(t.value);
}
function budgetResults(ctx, declaration, groups) {
    const priorities = priorityResults(ctx, declaration);
    const budgets = {};
    for (const b of budgetsOf(declaration, groups)) {
        if (typeof b.per !== 'string') {
            if (budgetKept(ctx, b, {}))
                budgets[b.key] = evaluateBudget(ctx, b, groups, priorities);
            continue;
        }
        // ONE BUDGET PER ROW (qa-runs 390): `per` names a repeating group, and the
        // budget is kept once for each of its rows, under `<key>:<row>`, with the
        // row bound for the pool and every spend's `where` - each casting class's
        // prepared spells against its own slots. No rows, no budget.
        const g = own(groups, b.per);
        if (!g) {
            budgets[b.key] = { key: b.key, label: typeof b.label === 'string' ? b.label : b.key, status: 'invalid', reason: { code: 'unknown-track', message: `no group named "${b.per}"` }, pool: null, spent: null, remaining: null, targets: [], violations: [] };
            continue;
        }
        const as = typeof g.as === 'string' && g.as ? g.as : g.key;
        const items = iterableFrom(ctx, g.over, 0);
        if (items.halt)
            continue;
        items.value.forEach((item, i) => {
            // A budget kept only where its `when` holds on the row: spells known
            // per level only for a class with a spells-known table at that level.
            if (!budgetKept(ctx, b, { [as]: item }))
                return;
            const row = item.address !== undefined ? item.address : i;
            const ref = item.value && typeof item.value === 'object' ? item.value.ref : undefined;
            const entry = typeof ref === 'string' ? own(ctx.content, ref) : undefined;
            const name = entry && typeof entry.name === 'string' ? entry.name
                : (entry && entry.attrs && typeof entry.attrs.name === 'string' ? entry.attrs.name : null);
            const label = `${typeof b.label === 'string' ? b.label : b.key}${name ? ` (${name})` : ''}`;
            const key = `${b.key}:${row}`;
            budgets[key] = { ...evaluateBudget({ ...ctx, perScope: { [as]: item } }, { ...b, key, label }, groups, priorities), per: b.per, row };
        });
    }
    return { budgets, priorities };
}
export { BUDGET_PHASES, evaluateSheet, evaluateRule, isTrue, OPERATIONS, MODIFIER_MODES, MAX_DEPTH, MAX_HOPS, stackModifiers };
//# sourceMappingURL=sheetEvaluator.js.map